<template>
    <div class="mt-3 checkout-flow-wrapper">
        <div v-if="openModal" ref="modal_custom" :class="{ 'overflow-hidden': overflowHidden  }">
            <div>
                <div>
                    <div>

                        <form ref="form" @submit.prevent="validateForm" method="POST" >
                            
                            <input type="hidden" class="form-control" name="event_id" :value="tickets && tickets.length ? tickets[0].event_id : null" >
                            <input type="hidden" class="form-control" name="booking_date" :value="serverTimezone(booking_date+' '+start_time, 'dddd LL HH:mm a').format('YYYY-MM-DD')" >

                            <input type="hidden" class="form-control" name="booking_end_date" 
                                :value="(booking_end_date != null && typeof(booking_end_date) != 'undefined' && booking_end_date != false) ? 
                                serverTimezone(moment(booking_date).format('dddd LL')+' '+end_time, 'dddd LL HH:mm a').locale('en').format('YYYY-MM-DD') : null" 
                                v-if="!event.merge_schedule"
                            >
                            <input type="hidden" class="form-control" name="booking_end_date" 
                                :value="(booking_end_date != null && typeof(booking_end_date) != 'undefined' && booking_end_date != false) ? 
                                serverTimezone(moment(booking_end_date).format('dddd LL')+' '+end_time, 'dddd LL HH:mm a').locale('en').format('YYYY-MM-DD') : null" 
                                v-else
                            >

                            <input type="hidden" class="form-control" name="start_time" :value="serverTimezone(booking_date+' '+start_time, 'dddd LL HH:mm a').format('HH:mm:ss')" >
                            <input type="hidden" class="form-control" name="end_time" :value="serverTimezone((booking_end_date == null ? booking_date : booking_end_date) +' '+end_time, 'dddd LL HH:mm a').format('HH:mm:ss')" >
                            <input type="hidden" class="form-control" name="merge_schedule" :value="event.merge_schedule" >
                            <input type="hidden" name="customer_id" v-model="customer_id" v-validate="'required'" >
                            
                            <div class="">
                                <!-- only for admin & organizer -->
                                <div class="row" v-if="is_customer <= 0">
                                    <div class="col-md-4 mb-3">
                                        <div v-if="is_customer <= 0">
                                            <label class="form-label h6" for="customer_id">{{ trans('em.select_customer') }}</label>
                                            <v-select 
                                                label="name" 
                                                class="form-control px-0 py-0 border-0 mb-2" 
                                                placeholder="Pesquisar por CPF, E-mail ou Nome"
                                                v-model="customer" 
                                                :required="!customer" 
                                                :filterable="false" 
                                                :options="options" 
                                                @search="onSearch" 
                                            ><div slot="no-options">{{ trans('em.customer_not_found') }}</div></v-select>
                                            <div class="invalid-feedback danger" v-show="errors.has('customer_id')">{{ errors.first('customer_id') }}</div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Event Status Alert -->
                                <div v-if="showEventStatusAlert()" class="alert mb-3" :class="getEventStatusAlertClass()">
                                    <div class="d-flex align-items-center">
                                        <i :class="getEventStatusIcon()" class="me-2"></i>
                                        <div>
                                            <strong>{{ getEventStatusTitle() }}</strong>
                                            <p class="mb-0 small">{{ getEventStatusMessage() }}</p>
                                        </div>
                                    </div>
                                </div>

                                <!-- Tickets -->
                                <div class="row">
                                    <div class="col-12">
                                        <!-- Marketing Mode - Show closed message instead of tickets -->
                                        <div v-if="event.event_status === 'marketing_mode'" class="text-center py-5">
                                            <i class="fas fa-times-circle text-danger mb-3" style="font-size: 3rem;"></i>
                                            <h4 class="text-danger">Vendas Encerradas</h4>
                                            <p class="text-muted">Este evento não está mais disponível para compra de ingressos.</p>
                                        </div>

                                        <!-- Inactive Mode - Show disabled message -->
                                        <div v-else-if="event.event_status === 'inactive_mode'" class="text-center py-5">
                                            <i class="fas fa-pause-circle text-secondary mb-3" style="font-size: 3rem;"></i>
                                            <h4 class="text-secondary">Evento Inativo</h4>
                                            <p class="text-muted">Este evento está temporariamente inativo.</p>
                                        </div>

                                        <!-- Normal ticket list for other statuses -->
                                        <div v-else>
                                            <div class="card border-0 shadow-sm checkout-section-card" :class="{ 'grayscale-tickets': event.event_status === 'inactive_mode' }">
                                                <div class="card-header bg-white border-0 py-3 d-flex flex-wrap justify-content-between align-items-center gap-2">
                                                    <div class="d-flex align-items-center gap-2">
                                                        <span class="checkout-step">1</span>
                                                        <div>
                                                            <div class="fw-bold">Ingressos</div>
                                                            <div class="small text-muted">Selecione o ingresso para iniciar</div>
                                                        </div>
                                                    </div>
                                                    <div class="d-flex align-items-center gap-2">
                                                        <span class="badge" :class="bookedTicketsTotal() > 0 ? 'bg-success' : 'bg-secondary'">
                                                            {{ bookedTicketsTotal() > 0 ? 'Selecionado' : 'Pendente' }}
                                                        </span>
                                                        <span v-if="bookedTicketsTotal() > 0" class="text-success"><i class="fas fa-check-circle"></i></span>
                                                    </div>
                                                </div>

                                                <div class="card-body pt-0">
                                                    <ul class="list-group list-group-flush">
                                                    <li class="list-group-item py-3"
                                                        v-for="(item, index) in tickets" 
                                                        :key = "index"
                                                    >
                                                <input type="hidden" class="formbh g-control" name="ticket_id[]" :value="item.id" >
                                                <input type="hidden" class="form-control" name="ticket_title[]" :value="item.title" >
                                                
                                                <div class="d-flex justify-content-between align-items-start lh-condensed flex-wrap gap-3">
                                                    <div class="w-40">
                                                        <h6 class="my-0"><strong>{{ item.title }}</strong></h6>
                                                        <p class="my-0 h6"><small>A partir de {{currency}}</small> {{ item.price > 0 ? item.price : '0.00' }}</p>
                                                    </div>
                                                    
                                                    <div class="w-20">
                                                        <!-- Live stock alert  -->
                                                        <!-- if any booked tickets -->
                                                        <div v-if='typeof(booked_tickets[item.id+"-"+booked_date_server]) != "undefined"
                                                        '>

                                                            <div v-if="!login_user_id" class="text-center">
                                                                <small class="text-muted">Faça login para selecionar</small>
                                                            </div>

                                                            <div v-else-if="useMultiParticipantCheckout" class="d-grid">
                                                                <button type="button" class="btn btn-outline-primary btn-sm" @click="selectSingleTicket(index)" :disabled="isTicketSelectionDisabled()">
                                                                    <span v-if="selectedTicketIndex === index"><i class="fas fa-check-circle text-success"></i> Selecionado</span>
                                                                    <span v-else>Selecionar</span>
                                                                </button>
                                                            </div>

                                                            <template v-else>
                                                                <select class="form-select border-2 form-select-lg" 
                                                                    name="quantity[]" 
                                                                    v-model="quantity[index]"
                                                                    v-if='(item.customer_limit != null ? item.customer_limit :  max_ticket_qty) <= 100'>
                                                                    <option value="0" selected>0</option>
                                                                    <option v-for="(itm, ind) in booked_tickets[item.id+'-'+booked_date_server].total_vacant" :key="'vacant-'+ind"
                                                                        v-if="booked_tickets[item.id+'-'+booked_date_server].total_vacant <= (item.customer_limit != null ? item.customer_limit :  max_ticket_qty)" 
                                                                        :value="itm"
                                                                    >{{itm }}</option>
                                                                    <option v-for="(itm, ind) in (item.quantity > (item.customer_limit != null ? item.customer_limit :  max_ticket_qty) ? parseInt(item.customer_limit != null ? item.customer_limit :  max_ticket_qty) : parseInt(item.quantity))" :key="'limit-'+ind"
                                                                        v-if="booked_tickets[item.id+'-'+booked_date_server].total_vacant > (item.customer_limit != null ? item.customer_limit :  max_ticket_qty)"
                                                                        :value="itm"
                                                                    >{{itm }}</option>
                                                                </select>
                                                                <input v-else type="number" name="quantity[]" 
                                                                    v-model="quantity[index]" value="0" class="form-control form-input-sm" 
                                                                    min="0" :max="booked_tickets[item.id+'-'+booked_date_server].total_vacant < (item.customer_limit != null ? item.customer_limit :  max_ticket_qty) ? booked_tickets[item.id+'-'+booked_date_server].total_vacant : (item.customer_limit != null ? item.customer_limit :  max_ticket_qty)"
                                                                >
                                                            </template>
                                                            <!-- Show if vacant less than max_ticket_qty -->
                                                            <p class="text-muted" 
                                                                v-if="booked_tickets[item.id+'-'+booked_date_server].total_vacant < (item.customer_limit != null ? item.customer_limit :  max_ticket_qty) && booked_tickets[item.id+'-'+booked_date_server].total_vacant > 0">
                                                                <small><i class="fas fa-exclamation"></i> {{ trans('em.vacant') }} 
                                                                {{ booked_tickets[item.id+'-'+booked_date_server].total_vacant }}</small>
                                                            </p>
                                                            <p class="text-danger" 
                                                                v-if="booked_tickets[item.id+'-'+booked_date_server].total_vacant < (item.customer_limit != null ? item.customer_limit :  max_ticket_qty) && booked_tickets[item.id+'-'+booked_date_server].total_vacant <= 0">
                                                                <small><i class="fas fa-times-circle"></i>  {{ trans('em.vacant') }} 0</small>
                                                            </p>
                                                        </div>
                                                        <div v-else>

                                                            <div v-if="!login_user_id" class="text-center">
                                                                <small class="text-muted">Faça login para selecionar</small>
                                                            </div>

                                                            <div v-else-if="useMultiParticipantCheckout" class="d-grid">
                                                                <button type="button" class="btn btn-outline-primary btn-sm" @click="selectSingleTicket(index)" :disabled="isTicketSelectionDisabled()">
                                                                    <span v-if="selectedTicketIndex === index"><i class="fas fa-check-circle text-success"></i> Selecionado</span>
                                                                    <span v-else>Selecionar</span>
                                                                </button>
                                                            </div>

                                                            <template v-else>
                                                                <select class="form-select border-2 form-select-lg" 
                                                                    name="quantity[]" 
                                                                    v-model="quantity[index]"
                                                                    @change="handleQuantityChange(index)"
                                                                    v-if="(item.customer_limit != null ? item.customer_limit :  max_ticket_qty) <= 100"
                                                                >
                                                                    <option value="0" selected>0</option>
                                                                    <option :value="itm" v-for=" (itm, ind) in item.quantity > (item.customer_limit != null ? item.customer_limit :  max_ticket_qty) ? parseInt((item.customer_limit != null ? item.customer_limit :  max_ticket_qty)) : parseInt(item.quantity)"  :key="ind">{{itm }}</option>
                                                                </select>
                                                                <input v-else type="number" name="quantity[]" v-model="quantity[index]" @input="handleQuantityChange(index)" value="0" class="form-control form-input-sm" min="0" :max="item.quantity > (item.customer_limit != null ? item.customer_limit :  max_ticket_qty) ? parseInt((item.customer_limit != null ? item.customer_limit :  max_ticket_qty)) : parseInt(item.quantity)">
                                                            </template>
                                                            <!-- Show if vacant less than max_ticket_qty -->
                                                            <p class="text-primary h6 text-nowrap" 
                                                                v-if="item.quantity < (item.customer_limit != null ? item.customer_limit :  max_ticket_qty) && item.quantity > 0">
                                                                <small><i class="fas fa-exclamation"></i> {{ trans('em.vacant') }} 
                                                                {{ item.quantity }}</small>
                                                            </p>
                                                            <p class="text-danger" 
                                                                v-if="item.quantity <= 0">
                                                                <small><i class="fas fa-times-circle"></i>  {{ trans('em.vacant') }} 0</small>
                                                            </p>
                                                        </div>
                                                    </div>

                                                    <div>
                                                        <strong>
                                                            <small>{{currency}}</small> {{ total_price[index] ? total_price[index] : '0.00' }}
                                                        </strong>
                                                        <span v-if="quantity[index] > 0"><i class="fas fa-check-circle text-success"></i></span>
                                                    </div>
                                                </div>

                                                <!-- show tax only if quantity is set -->
                                                <div class="break-flex w-30 w-m-100">
                                                    <ul class="list-group list-group-flush my-2" v-if="quantity[index] > 0 && item.price > 0 && item.taxes.length > 0">
                                                        <li class="list-group-item small px-2 p-1 text-muted" v-for="(tax, index1) in item.taxes" :key ="index1" v-if="tax.show_to_public == 1">
                                                            <span>{{ tax.title }} 
                                                                <small>{{ total_price[index] > 0 ? countTax(item.price, tax.rate, tax.rate_type, tax.net_price, quantity[index]) : 0 }}</small>
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>

                                                <div class="break-flex">
                                                    <!-- Segment Selector - Show when ticket has quantity > 0 and event has segment -->
                                                    <div v-if="!useMultiParticipantCheckout && quantity[index] > 0 && event.segment_id" class="segment-selector-wrapper">
                                                        <segment-selector
                                                            :ticket-id="item.id"
                                                            :event-id="event.id"
                                                            :quantity="quantity[index]"
                                                            @price-adjusted="onPriceAdjusted($event, index)"
                                                            @selection-changed="onSegmentSelectionChanged($event, index)"
                                                            :ref="`segmentSelector_${index}`"
                                                        />
                                                        
                                                        <!-- Segment Limit Validator - Show when limit validation is enabled -->
                                                        <segment-limit-validator
                                                            v-if="enable_limit_validation && segmentSelections[index]"
                                                            :ticket-id="item.id"
                                                            :quantity="quantity[index]"
                                                            :selected-values="segmentSelections[index]"
                                                            :show-progress="true"
                                                            @validation-result="onLimitValidation($event, index)"
                                                            class="mt-3"
                                                        />
                                                    </div>

                                                    <!-- Kit Variations Selector - Show when ticket has quantity > 0 and event has kit -->
                                                    <div v-if="!useMultiParticipantCheckout && quantity[index] > 0 && event.kit_id" class="kit-variations-selector-wrapper mt-3">
                                                        <div class="card border-light">
                                                            <div class="card-header bg-light py-2">
                                                                <h6 class="mb-0 text-primary">
                                                                    <i class="fas fa-box me-2"></i>
                                                                    Seleção de Variações do Kit
                                                                </h6>
                                                            </div>
                                                            <div class="card-body py-3">
                                                                <!-- Loading state -->
                                                                <div v-if="kitVariationsLoading" class="text-center py-3">
                                                                    <div class="spinner-border spinner-border-sm text-primary" role="status">
                                                                        <span class="visually-hidden">Carregando...</span>
                                                                    </div>
                                                                    <p class="small text-muted mt-2 mb-0">Carregando variações do kit...</p>
                                                                </div>
                                                                
                                                                <!-- Kit variations content -->
                                                                <div v-else-if="kitVariations.length > 0">
                                                                    <div v-for="(kitItem, kitIndex) in kitVariations" :key="kitItem.id" class="kit-item-group mb-3">
                                                                    <div class="variant-group mb-3">
                                                                        <label class="form-label fw-bold small">
                                                                            {{ kitItem.name }}
                                                                            <span v-if="kitItem.is_required" class="text-danger">*</span>
                                                                        </label>
                                                                        <select 
                                                                            :class="['form-select form-select-sm', { 'is-invalid': kitVariationErrors[`${index}_${kitIndex}`] }]"
                                                                            v-model="selectedKitVariations[index][kitIndex]"
                                                                            :required="kitItem.is_required"
                                                                            @change="validateKitVariations(index)"
                                                                        >
                                                                            <option value="">Selecione uma opção</option>
                                                                            <option 
                                                                                v-for="option in kitItem.options" 
                                                                                :key="option.id" 
                                                                                :value="option.value"
                                                                                :disabled="option.stock <= 0"
                                                                            >
                                                                                {{ option.label }}{{ option.stock <= 0 ? ' (Esgotado)' : (option.stock <= 5 ? ' (' + option.stock + ' restantes)' : '') }}
                                                                            </option>
                                                                        </select>
                                                                        <div v-if="kitVariationErrors[`${index}_${kitIndex}`]" class="invalid-feedback">
                                                                            {{ kitVariationErrors[`${index}_${kitIndex}`] }}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                </div>
                                                                <div v-else class="text-center py-2">
                                                                    <p v-if="kitVariationsLoadError" class="small text-danger mb-0">{{ kitVariationsLoadError }}</p>
                                                                    <p v-else class="small text-muted mb-0">Nenhuma variação de kit disponível.</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <!-- hide/show below ticket description -->
                                                    <a class="pointer ticket-info-toggle small" @click="ticket_info = !ticket_info">
                                                        <small v-if="ticket_info">{{ trans('em.hide_info') }}</small>
                                                        <small v-else>{{ trans('em.show_info') }}</small>
                                                    </a>
                                                    <p class="ticket-info small text-muted" v-if="ticket_info">{{ item.description }}</p>
                                                </div>
                                                
                                            </li>
                                        </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row" v-if="useMultiParticipantCheckout && login_user_id && !checkoutFlowStarted">
                                    <div class="col-12">
                                        <div class="d-grid mt-3">
                                            <button type="button" class="btn btn-primary btn-lg fw-bold checkout-cta" @click="startMultiCheckoutFlow" :disabled="disable || checkoutPreparing || isTicketSelectionDisabled() || !tickets || !tickets.length">
                                                INSCREVA-SE
                                            </button>
                                        </div>
                                        <div class="small text-muted mt-2" v-if="!checkoutFlowStarted">
                                            Clique em <strong>INSCREVA-SE</strong> para adicionar participantes e concluir o pagamento.
                                        </div>
                                    </div>
                                </div>

                                <div class="row" v-if="useMultiParticipantCheckout && bookedTicketsTotal() > 0 && login_user_id && checkoutFlowStarted">
                                    <div class="col-12">
                                        <div class="card border-0 shadow-sm checkout-section-card mt-4">
                                            <div class="card-header bg-white border-0 py-3 d-flex flex-wrap justify-content-between align-items-center gap-2" role="button" @click="toggleCheckoutSection('participants')">
                                                <h6 class="mb-0 text-primary">
                                                    <span class="checkout-step me-2">2</span>
                                                    <i class="fas fa-users me-2"></i>
                                                    Participantes
                                                </h6>
                                                <div class="d-flex align-items-center gap-2">
                                                    <span class="badge bg-primary" v-if="participants && participants.length">{{ (isGroupSale && requiredParticipantsCount) ? (participants.length + '/' + requiredParticipantsCount) : participants.length }}</span>
                                                    <span class="badge" :class="participantsConfirmed ? 'bg-success' : (participantsReadyForPayment ? 'bg-primary' : 'bg-secondary')">
                                                        {{ participantsConfirmed ? 'Salvo' : (participantsReadyForPayment ? 'Pronto' : 'Pendente') }}
                                                    </span>
                                                    <button v-if="participantsConfirmed" type="button" class="btn btn-sm btn-outline-secondary" @click.stop="editStep('participants')" :disabled="disable || checkoutPreparing">
                                                        <i class="fas fa-pen"></i>
                                                    </button>
                                                </div>

                                                <div class="w-100 pt-2">
                                                    <div class="checkout-progress">
                                                        <div class="checkout-progress-bar" :style="{ width: overallProgress + '%' }"></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <transition name="checkout-collapse">
                                                <div class="card-body py-3" v-show="activeCheckoutSection === 'participants'">
                                                    <div v-if="isGroupSale && requiredParticipantsCount" class="alert alert-info py-2 small mb-3">
                                                        Este ingresso exige exatamente <strong>{{ requiredParticipantsCount }}</strong> participante(s).
                                                        <span v-if="participants && participants.length < requiredParticipantsCount">
                                                            Faltam <strong>{{ requiredParticipantsCount - participants.length }}</strong>.
                                                        </span>
                                                    </div>
                                                    <div class="row g-2 mb-3">
                                                    <div class="col-12 col-md-6 d-grid" v-if="!primaryParticipantChoice || primaryParticipantChoice === 'self'">
                                                        <button
                                                            type="button"
                                                            :class="['btn', primaryParticipantChoice === 'self' ? 'btn-success' : 'btn-outline-primary']"
                                                            :title="primaryParticipantChoice === 'self' ? 'Clique para editar' : null"
                                                            @click.stop="onPrimaryChoiceClick('self')"
                                                            :disabled="disable || checkoutPreparing"
                                                        >
                                                            <i v-if="primaryParticipantChoice === 'self'" class="fas fa-check-circle me-2"></i>
                                                            Inscrição é para o(a) <strong>{{ currentUserFirstName }}</strong>
                                                            <i v-if="primaryParticipantChoice === 'self'" class="fas fa-pen ms-2"></i>
                                                        </button>
                                                    </div>
                                                    <div class="col-12 col-md-6 d-grid" v-if="!primaryParticipantChoice || primaryParticipantChoice === 'other'">
                                                        <button
                                                            type="button"
                                                            :class="['btn', primaryParticipantChoice === 'other' ? 'btn-success' : 'btn-outline-primary']"
                                                            :title="primaryParticipantChoice === 'other' ? 'Clique para editar' : null"
                                                            @click.stop="onPrimaryChoiceClick('other')"
                                                            :disabled="disable || checkoutPreparing"
                                                        >
                                                            <i v-if="primaryParticipantChoice === 'other'" class="fas fa-check-circle me-2"></i>
                                                            Outro participante
                                                            <i v-if="primaryParticipantChoice === 'other'" class="fas fa-pen ms-2"></i>
                                                        </button>
                                                    </div>
                                                </div>

                                                <div v-if="primaryParticipantChoice === 'other' && !primaryParticipant" class="mb-3">
                                                    <div class="row g-2 align-items-stretch">
                                                        <div class="col-12 col-md-8">
                                                            <div class="input-group">
                                                                <span class="input-group-text bg-white"><i class="fas fa-id-card"></i></span>
                                                                <input type="text" class="form-control" v-model="primaryParticipantCpf" placeholder="CPF do participante" :disabled="disable || checkoutPreparing || resolvingPrimaryParticipant" />
                                                            </div>
                                                        </div>
                                                        <div class="col-12 col-md-4 d-grid">
                                                            <button type="button" class="btn btn-primary" @click.stop="setPrimaryParticipantByCpf" :disabled="disable || checkoutPreparing || resolvingPrimaryParticipant || !primaryParticipantCpf">
                                                                Confirmar
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div v-if="primaryParticipant" class="card border-0 shadow-sm checkout-participant-card mb-3">
                                                    <div class="card-body p-3">
                                                    <div class="d-flex justify-content-between align-items-center">
                                                        <div>
                                                            <div><strong>{{ primaryParticipant.name || 'Participante 1' }}</strong></div>
                                                            <div class="small text-muted" v-if="primaryParticipant.social_name">Nome social: {{ primaryParticipant.social_name }}</div>
                                                            <div class="small text-muted" v-if="primaryParticipant.document">{{ formatCpf(primaryParticipant.document) }}</div>
                                                        </div>
                                                    </div>

                                                    <div v-if="useMultiParticipantCheckout" class="mt-3">
                                                        <courtesy-code
                                                            :event-id="event ? event.id : null"
                                                            :total-amount="getParticipantCourtesyBaseAmount(primaryParticipant.user_id)"
                                                            :tax-amount="getParticipantCourtesyTaxAmount(primaryParticipant.user_id)"
                                                            :booking-id="null"
                                                            :is-courtesy-required="isCourtesyCodeRequired()"
                                                            @discount-applied="onParticipantCourtesyApplied($event, primaryParticipant.user_id)"
                                                            @discount-removed="onParticipantCourtesyRemoved(primaryParticipant.user_id)"
                                                        />
                                                    </div>

                                                    <div v-if="event.segment_id" class="mt-3">
                                                        <segment-selector
                                                            :ticket-id="selectedTicket ? selectedTicket.id : null"
                                                            :event-id="event.id"
                                                            :quantity="1"
                                                            :discount-multiplier="getParticipantDiscountMultiplier(primaryParticipant.user_id)"
                                                            @price-adjusted="onParticipantPriceAdjusted($event, 0)"
                                                            @selection-changed="onParticipantSegmentSelectionChanged($event, 0)"
                                                            :ref="`segmentSelector_participant_0`"
                                                        />
                                                    </div>

                                                    <div v-if="event.kit_id" class="mt-3">
                                                        <div class="card border-light">
                                                            <div class="card-header bg-light py-2">
                                                                <h6 class="mb-0 text-primary">
                                                                    <i class="fas fa-box me-2"></i>
                                                                    Seleção de Variações do Kit
                                                                </h6>
                                                            </div>
                                                            <div class="card-body py-3">
                                                                <div v-if="kitVariationsLoading" class="text-center py-3">
                                                                    <div class="spinner-border spinner-border-sm text-primary" role="status">
                                                                        <span class="visually-hidden">Carregando...</span>
                                                                    </div>
                                                                    <p class="small text-muted mt-2 mb-0">Carregando variações do kit...</p>
                                                                </div>

                                                                <div v-else-if="kitVariations.length > 0">
                                                                    <div v-for="(kitItem, kitIndex) in kitVariations" :key="`kititem_0_${kitItem.id}`" class="kit-item-group mb-3">
                                                                        <div class="variant-group mb-3">
                                                                            <label class="form-label fw-bold small">
                                                                                {{ kitItem.name }}
                                                                                <span v-if="kitItem.is_required" class="text-danger">*</span>
                                                                            </label>
                                                                            <select
                                                                                :class="['form-select form-select-sm', { 'is-invalid': participantKitErrors[`0_${kitIndex}`] }]"
                                                                                v-model="primaryParticipant.kit_variations[kitIndex]"
                                                                                :required="kitItem.is_required"
                                                                                @change="onParticipantKitChanged(0)"
                                                                            >
                                                                                <option value="">Selecione uma opção</option>
                                                                                <option
                                                                                    v-for="option in kitItem.options"
                                                                                    :key="option.id"
                                                                                    :value="option.value"
                                                                                    :disabled="option.stock <= 0"
                                                                                >
                                                                                    {{ option.label }}{{ option.stock <= 0 ? ' (Esgotado)' : (option.stock <= 5 ? ' (' + option.stock + ' restantes)' : '') }}
                                                                                </option>
                                                                            </select>
                                                                            <div v-if="participantKitErrors[`0_${kitIndex}`]" class="invalid-feedback">
                                                                                {{ participantKitErrors[`0_${kitIndex}`] }}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div v-else class="text-center py-2">
                                                                    <p v-if="kitVariationsLoadError" class="small text-danger mb-0">{{ kitVariationsLoadError }}</p>
                                                                    <p v-else class="small text-muted mb-0">Nenhuma variação de kit disponível.</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    </div>
                                                </div>

                                                <div v-for="(participant, extraIndex) in extraParticipants" :key="`participant_${participant.user_id}_${extraIndex + 1}`" class="card border-0 shadow-sm checkout-participant-card mb-3">
                                                    <div class="card-body p-3">
                                                    <div class="d-flex justify-content-between align-items-start flex-wrap gap-2">
                                                        <div>
                                                            <div><strong>{{ participant.name || ('Participante ' + (extraIndex + 2)) }}</strong></div>
                                                            <div class="small text-muted" v-if="participant.social_name">Nome social: {{ participant.social_name }}</div>
                                                            <div class="small text-muted" v-if="participant.document">{{ formatCpf(participant.document) }}</div>
                                                        </div>
                                                        <div class="d-grid d-md-inline">
                                                            <button type="button" class="btn btn-sm btn-outline-danger" @click="removeParticipant(extraIndex + 1)" :disabled="disable || checkoutPreparing || addingParticipant">Remover</button>
                                                        </div>
                                                    </div>

                                                    <div v-if="useMultiParticipantCheckout" class="mt-3">
                                                        <courtesy-code
                                                            :event-id="event ? event.id : null"
                                                            :total-amount="getParticipantCourtesyBaseAmount(participant.user_id)"
                                                            :tax-amount="getParticipantCourtesyTaxAmount(participant.user_id)"
                                                            :booking-id="null"
                                                            :is-courtesy-required="isCourtesyCodeRequired()"
                                                            @discount-applied="onParticipantCourtesyApplied($event, participant.user_id)"
                                                            @discount-removed="onParticipantCourtesyRemoved(participant.user_id)"
                                                        />
                                                    </div>

                                                    <div v-if="event.segment_id" class="mt-3">
                                                        <segment-selector
                                                            :ticket-id="selectedTicket ? selectedTicket.id : null"
                                                            :event-id="event.id"
                                                            :quantity="1"
                                                            :discount-multiplier="getParticipantDiscountMultiplier(participant.user_id)"
                                                            @price-adjusted="onParticipantPriceAdjusted($event, extraIndex + 1)"
                                                            @selection-changed="onParticipantSegmentSelectionChanged($event, extraIndex + 1)"
                                                            :ref="`segmentSelector_participant_${extraIndex + 1}`"
                                                        />
                                                    </div>

                                                    <div v-if="event.kit_id" class="mt-3">
                                                        <div class="card border-light">
                                                            <div class="card-header bg-light py-2">
                                                                <h6 class="mb-0 text-primary">
                                                                    <i class="fas fa-box me-2"></i>
                                                                    Seleção de Variações do Kit
                                                                </h6>
                                                            </div>
                                                            <div class="card-body py-3">
                                                                <div v-if="kitVariationsLoading" class="text-center py-3">
                                                                    <div class="spinner-border spinner-border-sm text-primary" role="status">
                                                                        <span class="visually-hidden">Carregando...</span>
                                                                    </div>
                                                                    <p class="small text-muted mt-2 mb-0">Carregando variações do kit...</p>
                                                                </div>

                                                                <div v-else-if="kitVariations.length > 0">
                                                                    <div v-for="(kitItem, kitIndex) in kitVariations" :key="`kititem_${extraIndex + 1}_${kitItem.id}`" class="kit-item-group mb-3">
                                                                        <div class="variant-group mb-3">
                                                                            <label class="form-label fw-bold small">
                                                                                {{ kitItem.name }}
                                                                                <span v-if="kitItem.is_required" class="text-danger">*</span>
                                                                            </label>
                                                                            <select
                                                                                :class="['form-select form-select-sm', { 'is-invalid': participantKitErrors[`${extraIndex + 1}_${kitIndex}`] }]"
                                                                                v-model="participant.kit_variations[kitIndex]"
                                                                                :required="kitItem.is_required"
                                                                                @change="onParticipantKitChanged(extraIndex + 1)"
                                                                            >
                                                                                <option value="">Selecione uma opção</option>
                                                                                <option
                                                                                    v-for="option in kitItem.options"
                                                                                    :key="option.id"
                                                                                    :value="option.value"
                                                                                    :disabled="option.stock <= 0"
                                                                                >
                                                                                    {{ option.label }}{{ option.stock <= 0 ? ' (Esgotado)' : (option.stock <= 5 ? ' (' + option.stock + ' restantes)' : '') }}
                                                                                </option>
                                                                            </select>
                                                                            <div v-if="participantKitErrors[`${extraIndex + 1}_${kitIndex}`]" class="invalid-feedback">
                                                                                {{ participantKitErrors[`${extraIndex + 1}_${kitIndex}`] }}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div v-else class="text-center py-2">
                                                                    <p v-if="kitVariationsLoadError" class="small text-danger mb-0">{{ kitVariationsLoadError }}</p>
                                                                    <p v-else class="small text-muted mb-0">Nenhuma variação de kit disponível.</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                </div>

                                                <div class="d-grid mt-3" v-if="participantsReadyForPayment">
                                                    <button type="button" class="btn btn-outline-primary" @click="confirmParticipants" :disabled="participantsConfirmed">
                                                        {{ participantsConfirmed ? 'Participantes confirmados' : 'Confirmar participantes' }}
                                                    </button>
                                                </div>

                                                <div v-if="primaryParticipant" class="mt-3">
                                                    <div class="d-grid">
                                                        <button type="button" class="btn btn-primary" @click.stop="toggleAddParticipantForm" :disabled="disable || checkoutPreparing || addingParticipant || !canAddParticipant">
                                                            <i class="fas fa-user-plus me-1"></i>
                                                            Adicionar participante
                                                        </button>
                                                    </div>

                                                    <div v-show="showAddParticipantForm">
                                                        <div class="row g-2 align-items-stretch mt-2">
                                                            <div class="col-12 col-md-8">
                                                                <div class="input-group">
                                                                    <span class="input-group-text bg-white"><i class="fas fa-id-card"></i></span>
                                                                    <input type="text" class="form-control" v-model="newParticipantCpf" placeholder="CPF do participante" :disabled="disable || checkoutPreparing || addingParticipant" />
                                                                </div>
                                                            </div>
                                                            <div class="col-12 col-md-4 d-grid">
                                                                <button type="button" class="btn btn-primary" @click="addParticipantByCpf" :disabled="disable || checkoutPreparing || addingParticipant || !canAddParticipant || !newParticipantCpf">
                                                                    <i class="fas fa-plus"></i>
                                                                    Adicionar
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div class="small text-muted mt-2" v-if="!canAddParticipant">{{ (isGroupSale && requiredParticipantsCount && participants && participants.length >= requiredParticipantsCount) ? 'Grupo completo.' : 'Limite atingido ou sem disponibilidade para adicionar mais participantes.' }}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            </transition>
                                        </div>
                                    </div>
                                </div>

                                <div class="row" v-if="login_user_id && bookedTicketsTotal() > 0 && event && event.kit_id && (!useMultiParticipantCheckout || (checkoutFlowStarted && primaryParticipant))">
                                    <div class="col-12">
                                        <div class="card border-light mt-3 kit-preview-card">
                                            <div class="card-header bg-light py-2 d-flex justify-content-between align-items-center flex-wrap gap-2">
                                                <h6 class="mb-0 text-primary">
                                                    <i class="fas fa-gift me-2"></i>
                                                    Itens do kit
                                                </h6>
                                                <div class="small text-muted" v-if="kitPreview && kitPreview.kit && kitPreview.kit.name">
                                                    {{ kitPreview.kit.name }}
                                                </div>
                                            </div>
                                            <div class="card-body py-3">
                                                <div v-if="kitPreviewLoading" class="text-center py-3">
                                                    <div class="spinner-border spinner-border-sm text-primary" role="status">
                                                        <span class="visually-hidden">Carregando...</span>
                                                    </div>
                                                    <p class="small text-muted mt-2 mb-0">Carregando itens do kit...</p>
                                                </div>
                                                <div v-else-if="kitPreview && kitPreview.items && kitPreview.items.length > 0">
                                                    <div class="row g-2 g-md-3">
                                                        <div v-for="kitItem in kitPreview.items" :key="kitItem.id" class="col-6 col-md-4 col-lg-3">
                                                            <div class="card h-100 border-0 shadow-sm kit-preview-item">
                                                                <div class="ratio ratio-1x1 bg-light rounded-top overflow-hidden">
                                                                    <img v-if="kitItem.image" :src="getKitPreviewImageUrl(kitItem.image)" class="w-100 h-100 kit-preview-img">
                                                                    <div v-else class="w-100 h-100 d-flex align-items-center justify-content-center text-muted small">
                                                                        Sem imagem
                                                                    </div>
                                                                </div>
                                                                <div class="card-body p-2 p-md-3">
                                                                    <div class="fw-semibold small text-truncate" :title="kitItem.name">{{ kitItem.name }}</div>
                                                                    <div v-if="kitItem.description" class="small text-muted kit-preview-desc preserve-whitespace">{{ kitItem.description }}</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-else class="text-muted small">
                                                    Kit vinculado ao evento, mas sem itens disponíveis para exibição.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Add-ons -->
                                <div class="row" v-if="bookedTicketsTotal() > 0 && addons.length > 0 && (!useMultiParticipantCheckout || (checkoutFlowStarted && primaryParticipant))">
                                    <div class="col-12">
                                        <div class="card border-0 shadow-sm checkout-section-card mt-4">
                                            <div class="card-header bg-white border-0 py-3">
                                                <h6 class="mb-0 text-primary">
                                                    <i class="fas fa-check-square me-2"></i>
                                                    Itens adicionais
                                                </h6>
                                            </div>
                                            <div class="card-body py-3">
                                                <div v-if="addonsLoading" class="text-center py-3">
                                                    <div class="spinner-border spinner-border-sm text-primary" role="status">
                                                        <span class="visually-hidden">Carregando...</span>
                                                    </div>
                                                    <p class="small text-muted mt-2 mb-0">Carregando itens adicionais...</p>
                                                </div>
                                                <div v-else>
                                                    <div v-for="addon in addons" :key="addon.id" class="mb-3">
                                                        <div class="form-check">
                                                            <input
                                                                class="form-check-input"
                                                                type="checkbox"
                                                                :id="`addon_${addon.id}`"
                                                                :value="addon.id"
                                                                v-model="selectedAddonIds"
                                                                @change="onAddonSelectionChanged"
                                                            >
                                                            <label class="form-check-label" :for="`addon_${addon.id}`">
                                                                <strong>{{ addon.name }}</strong>
                                                                <span class="text-muted">
                                                                    - <small>{{ currency }}</small> {{ formatMoney(addon.price) }}
                                                                    <small v-if="addon.pricing_type === 'per_ticket'"> por inscrição</small>
                                                                    <small v-else> por pedido</small>
                                                                </span>
                                                            </label>
                                                        </div>
                                                        <div v-if="addon.description" class="small text-muted ms-4 mt-1">
                                                            {{ addon.description }}
                                                        </div>
                                                    </div>

                                                    <div class="d-flex justify-content-between border-top pt-2" v-if="addonsTotal() > 0">
                                                        <span class="small text-muted">Total itens adicionais</span>
                                                        <strong class="small"><small>{{ currency }}</small> {{ formatMoney(addonsTotal()) }}</strong>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row" v-if="login_user_id && bookedTicketsTotal() > 0 && (!useMultiParticipantCheckout || (checkoutFlowStarted && primaryParticipant))">
                                    <div class="col-12">
                                        <div ref="checkoutCartCard" class="card border-0 shadow-sm checkout-section-card mt-4">
                                            <div class="card-header bg-white border-0 py-3 d-flex flex-wrap justify-content-between align-items-center gap-2" role="button" @click="toggleCheckoutSection('cart')">
                                                <div class="d-flex align-items-center gap-2">
                                                    <span class="checkout-step">3</span>
                                                    <div>
                                                        <div class="fw-bold">Carrinho</div>
                                                        <div class="small text-muted">Revise os totais antes do pagamento</div>
                                                    </div>
                                                </div>
                                                <div class="d-flex align-items-center gap-2">
                                                    <span class="badge" :class="cartConfirmed ? 'bg-success' : (participantsConfirmed ? 'bg-primary' : 'bg-secondary')">
                                                        {{ cartConfirmed ? 'Salvo' : (participantsConfirmed ? 'Pronto' : 'Pendente') }}
                                                    </span>
                                                    <button v-if="cartConfirmed" type="button" class="btn btn-sm btn-outline-secondary" @click.stop="editStep('cart')" :disabled="disable || checkoutPreparing">
                                                        <i class="fas fa-pen"></i>
                                                    </button>
                                                </div>

                                                <div class="w-100 pt-2">
                                                    <div class="checkout-progress">
                                                        <div class="checkout-progress-bar" :style="{ width: overallProgress + '%' }"></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <transition name="checkout-collapse">
                                                <div class="card-body p-3" v-show="!useMultiParticipantCheckout || activeCheckoutSection === 'cart'">
                                                <div class="d-flex justify-content-between align-items-center">
                                                    <div class="text-muted">{{ trans('em.total_tickets') }}</div>
                                                    <div class="fw-bold">{{ bookedTicketsTotal() }}</div>
                                                </div>
                                                <div class="d-flex justify-content-between align-items-center mt-2">
                                                    <div class="text-muted">{{ trans('em.total_order') }}</div>
                                                    <div class="fw-bold"><small>{{currency}}</small> {{ total }}</div>
                                                </div>

                                                <div class="d-grid mt-3" v-if="useMultiParticipantCheckout && participantsConfirmed">
                                                    <button type="button" class="btn btn-outline-primary" @click="confirmCart" :disabled="cartConfirmed">
                                                        {{ cartConfirmed ? 'Carrinho confirmado' : 'Confirmar carrinho' }}
                                                    </button>
                                                </div>
                                            </div>
                                            </transition>
                                        </div>
                                    </div>
                                </div>

                                <!-- Courtesy Code Section -->
                                <div class="row" v-if="!useMultiParticipantCheckout && bookedTicketsTotal() > 0 && login_user_id">
                                    <div class="col-12">
                                        <courtesy-code
                                            :event-id="event ? event.id : null"
                                            :total-amount="parseFloat(total) || 0"
                                            :tax-amount="courtesyTaxAmount"
                                            :tickets="courtesyTicketsPayload"
                                            :booking-id="null"
                                            :is-courtesy-required="isCourtesyCodeRequired()"
                                            @discount-applied="onDiscountApplied"
                                            @discount-removed="onDiscountRemoved"
                                        />
                                        <!-- Debug info -->
                                        <div v-if="false" class="mt-2 p-2 bg-light border rounded">
                                            <small>
                                                <strong>Debug:</strong><br>
                                                Total: {{ total }}<br>
                                                ParseFloat Total: {{ parseFloat(total) }}<br>
                                                Booked Tickets: {{ bookedTicketsTotal() }}<br>
                                                Total Price Array: {{ JSON.stringify(total_price) }}
                                            </small>
                                        </div>
                                    </div>
                                </div>

                                <!-- If not logged in -->
                                <div class="row" v-if="!login_user_id">
                                    <div class="col-12">
                                        <div class="w-100 mb-3" >
                                            <div class="alert alert-danger">
                                                {{ trans('em.please_login_signup') }}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Payment -->
                                <div class="row" v-if="bookedTicketsTotal() > 0 && login_user_id && (!useMultiParticipantCheckout || (checkoutFlowStarted && primaryParticipant))">
                                    <div class="col-12 mb-3">
                                        <div class="card border-0 shadow-sm checkout-section-card mt-4">
                                            <div class="card-header bg-white border-0 py-3 d-flex flex-wrap justify-content-between align-items-center gap-2" role="button" @click="toggleCheckoutSection('payment')">
                                                <div class="d-flex align-items-center gap-2">
                                                    <span class="checkout-step">4</span>
                                                    <div class="fw-bold text-primary">
                                                        <i class="fas fa-credit-card me-2"></i>
                                                        Pagamento
                                                    </div>
                                                </div>
                                                <div class="d-flex align-items-center gap-2">
                                                    <span class="badge" :class="paymentConfirmed ? 'bg-success' : ((useMultiParticipantCheckout ? cartConfirmed : true) ? 'bg-primary' : 'bg-secondary')">
                                                        {{ paymentConfirmed ? 'Pago' : (((useMultiParticipantCheckout ? cartConfirmed : true)) ? 'Pronto' : 'Pendente') }}
                                                    </span>
                                                    <span v-if="showPaymentForm || paymentConfirmed" class="text-success"><i class="fas fa-check-circle"></i></span>
                                                </div>

                                                <div class="w-100 pt-2">
                                                    <div class="checkout-progress">
                                                        <div class="checkout-progress-bar" :style="{ width: overallProgress + '%' }"></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <transition name="checkout-collapse">
                                                <div class="card-body p-3" v-show="!useMultiParticipantCheckout || activeCheckoutSection === 'payment'">
                                                <div class="payment-options">
                                                    <div v-if="!useMultiParticipantCheckout" class="border rounded border-1 border-dark list-group-flush px-2 bg-white">
                                                        <!-- Free -->
                                                        <div class="d-block my-3 pl-3" v-if="total <= 0">
                                                            <div class="radio-inline">
                                                                <input id="free_order" name="free_order" type="radio" class="custom-control-input" checked>
                                                                <label class="custom-control-label" for="free_order"> &nbsp;<i class="fas fa-glass-cheers"></i> {{ trans('em.free') }}</label>
                                                            </div>
                                                        </div>

                                                        <!-- Paid -->
                                                        <div class="d-block my-3 pl-3" v-else>
                                                            <!-- For Organizer & Customer -->
                                                            <div class="radio-inline" v-if="is_admin <= 0 && is_paypal > 0">
                                                                <input type="radio" class="custom-control-input" id="payment_method_paypal" name="payment_method" v-model="payment_method" value="1" >
                                                                <label class="custom-control-label" for="payment_method_paypal"> &nbsp;<i class="fab fa-paypal"></i> PayPal</label>
                                                            </div>

                                                            <!-- Mercado Pago -->
                                                            <div class="radio-inline" v-if="is_mercadopago > 0">
                                                                <input type="radio" class="custom-control-input" id="payment_method_mercadopago" name="payment_method" v-model="payment_method" value="2" >
                                                                <label class="custom-control-label" for="payment_method_mercadopago"> &nbsp;<i class="fas fa-credit-card"></i> Mercado Pago</label>
                                                            </div>

                                                            <!-- For Admin & Organizer & Customer -->
                                                            <div class="radio-inline" 
                                                                v-if="(is_organiser > 0 && is_offline_payment_organizer > 0) || (is_customer > 0 && is_offline_payment_customer > 0) || (is_admin > 0)">
                                                                <input type="radio" class="custom-control-input" id="payment_method_offline" name="payment_method" v-model="payment_method" value="offline">

                                                                <label class="custom-control-label" for="payment_method_offline"> 
                                                                    &nbsp;<i class="fas fa-suitcase-rolling"></i> {{ trans('em.offline') }} 
                                                                    <small>({{ trans('em.cash_on_arrival') }})</small>
                                                                </label>
                                                            </div>

                                                            <p v-if="payment_method == 'offline'" class="text-mute h6 px-3 mt-1"><strong>{{ trans('em.offline_payment_info') }}: </strong><small class="preserve-whitespace" v-html="event.offline_payment_info"></small></p>
                                                            <p class="text-mute h6 mt-2 mx-3" v-html="trans('em.order_terms')"></p>
                                                        </div>
                                                    </div>

                                                    <div v-else class="alert alert-light border mb-0">
                                                        <strong>Pagamento</strong>
                                                        <div class="small text-muted">Clique em <strong>Forma de pagamento</strong> para escolher Pix ou Cartão.</div>
                                                    </div>
                                                </div>
                                    
                                    <!-- Mercado Pago Checkout Form -->
                                    <div class="mt-4" v-if="((!useMultiParticipantCheckout && payment_method == 2) || (useMultiParticipantCheckout && showPaymentForm)) && total > 0">
                                        <mercadopago-checkout
                                            ref="mercadoPagoCheckout"
                                            :event-id="event ? event.id : null"
                                            :order-id="checkoutOrderId"
                                            :participants="participantsForCheckout"
                                            :tickets="tickets"
                                            :total="parseFloat(total)"
                                            :subtotal-amount="parseFloat(orderSubtotal)"
                                            :tax-amount="parseFloat(orderTaxTotal)"
                                            :currency="currency"
                                            :booking-data="{
                                                booking_date: booking_date,
                                                booking_end_date: booking_end_date,
                                                start_time: start_time,
                                                end_time: end_time,
                                                courtesy_codes: courtesyCodesByUserId,
                                                courtesyDiscount: courtesyDiscount
                                            }"
                                            :payment-methods="paymentMethods"
                                            :installment-options="installmentOptions"
                                            @waiting-payment-changed="isWaitingPayment = $event"
                                            @payment-confirmed-changed="paymentConfirmed = $event"
                                        />
                                    </div>

                                    <!-- Terms and Regulations Section -->
                                    <div class="mt-3" v-if="!paymentConfirmed">
                                        <div class="card border-light">
                                            <div class="card-body p-3">
                                                <!-- Terms Checkbox -->
                                                <div class="form-check mb-2">
                                                    <input 
                                                        type="checkbox" 
                                                        class="form-check-input" 
                                                        id="acceptTerms"
                                                        v-model="acceptTerms"
                                                        required
                                                    >
                                                    <label class="form-check-label" for="acceptTerms">
                                                        Aceito os <a href="https://eventos.inovmi.com.br/pages/terms" target="_blank">Termos de Serviço</a> e <a href="https://eventos.inovmi.com.br/pages/privacy" target="_blank">Política de Privacidade</a> da Participe Eventos
                                                    </label>
                                                </div>
                                                
                                                <small class="text-muted d-block mb-3">
                                                    Este pedido está sujeito aos Termos de Serviço e à Política de Privacidade da Participe Eventos.
                                                </small>
                                                
                                                <!-- Regulamento Checkbox -->
                                                <div class="form-check">
                                                    <input 
                                                        type="checkbox" 
                                                        class="form-check-input" 
                                                        id="acceptRegulamento"
                                                        v-model="acceptRegulamento"
                                                        required
                                                    >
                                                    <label class="form-check-label" for="acceptRegulamento">
                                                        <strong>Li e aceito o regulamento do evento</strong>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Checkout Button - Positioned Below Form -->
                                    <!-- Esconder botão quando pagamento confirmado, desabilitar quando aguardando -->
                                    <div class="mt-2 pb-2" v-if="!paymentConfirmed">
                                        <div class="d-grid">
                                            <div class="btn-group btn-group-md btn-block  btn-group-justified">
                                                <button :class="{ 'disabled' : disable || isWaitingPayment || !acceptTerms || !acceptRegulamento }" :disabled="disable || isWaitingPayment || !acceptTerms || !acceptRegulamento" type="button" class="btn btn-success btn-lg btn-block fw-bold text-white" @click="bookTickets()">
                                                    <i class="fas fa-lock"></i> 
                                                    {{ useMultiParticipantCheckout && !showPaymentForm ? 'Forma de pagamento' : trans('em.checkout') }}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                                </div>
                                            </transition>
                                        </div>
                                    </div>
                                </div>

                                <!-- Action -->
                                <div class="row">
                                    <div class="col-12">
                                        <div v-if="!login_user_id">
                                            <div class="d-grid pb-4">
                                                <div class="btn-group btn-group-md btn-block  btn-group-justified">
                                                    <button type="button" class="btn btn-primary btn-lg fw-bold checkout-cta" @click="loginFirst()">INSCREVA-SE</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>

                        </form>
                        
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

import { mapState, mapMutations} from 'vuex';
import mixinsFilters from '../../mixins.js';
import _ from 'lodash';

export default {
    
    mixins:[
        mixinsFilters
    ],

    components: {
        'mercadopago-checkout': () => import('./MercadoPagoCheckout.vue'),
        'segment-selector': () => import('./SegmentSelector.vue'),
        'segment-limit-validator': () => import('../../../../../resources/js/components/SegmentLimitValidator.vue'),
        'courtesy-code': () => import('./CourtesyCode.vue')
    },

    created() {
        // Load kit variations if event has kit
        if (this.event && this.event.kit_id) {
            this.loadKitVariations();
            this.loadKitPreview();
        }

        if (this.event && this.event.id) {
            this.loadAddons();
        }
    },
    props : [
        'tickets', 
        'max_ticket_qty', 
        'event', 
        'currency', 
        'login_user_id',
        'is_admin',
        'is_organiser',
        'is_customer',
        'is_paypal',
        'is_mercadopago',
        'is_offline_payment_organizer',
        'is_offline_payment_customer',
        'booked_tickets',
        'enable_limit_validation',
    ],

    data() {
        return {
            openModal           : false,
            ticket_info         : false,    
            moment              : moment,
            overflowHidden      : false,
            quantity            : [1],
            price               : null,
            total_price         : [],
            customer_id         : 0,
            total               : 0,   
            disable             : false,
            payment_method      : 'offline',   
            
            // customers options
            options             : [],
            //selected customer
            customer            : null,

            cardName    : "",
            cardNumber  : "",
            cardMonth   : "",
            cardYear    : "",
            cardCvv     : "",
            paymentMethods: {
                credit_card: true,
                debit_card: true,
                boleto: true,
                pix: true,
                wallet: true
            },
            installmentOptions: this.generateInstallments(12),
            
            // 🔑 NOVO: Estados do Mercado Pago
            isWaitingPayment: false,
            paymentConfirmed: false,
            
            // 🎯 NOVO: Estados de Segmentação
            segmentPriceAdjustments: {},
            segmentSelections: {},
            segmentSelectionsPayload: {},
            
            // � NOVO: Estados de Validação de Limites
            limitValidationResults: {},
            limitValidationErrors: {},
            
            // �📦 NOVO: Estados de Variações do Kit
            kitVariations: [],
            kitVariationsLoading: false,
            kitVariationsLoadError: '',
            selectedKitVariations: {},
            kitVariationErrors: {},
            kitPreview: null,
            kitPreviewLoading: false,
            
            // f NOVO: Estados de Add-ons
            addons: [],
            addonsLoading: false,
            selectedAddonIds: [],
            
            // 🎫 NOVO: Estados de Cortesia
            courtesyDiscount: null,
            originalTotal: 0,
            courtesyCodesByUserId: {},
            participantsBaseTotalsByUserId: {},
            requiresCourtesyCodes: false,
            participantCourtesyDiscountMultiplierByUserId: {},
            
            // ✅ NOVO: Estados dos checkboxes de termos
            acceptTerms: false,
            acceptRegulamento: false,

            participants: [],
            newParticipantCpf: '',
            checkoutOrderId: null,
            checkoutPreparing: false,
            canAddParticipant: true,
            addingParticipant: false,
            selectedTicketIndex: null,
            participantKitErrors: {},
            showPaymentForm: false,
            requiresSegmentSelections: false,
            requiresKitSelections: false,
            isGroupSale: false,
            requiredParticipantsCount: null,
            requiresParticipantsCount: false,
            checkoutFlowStarted: false,
            activeCheckoutSection: 'tickets',
            showAddParticipantForm: false,
            primaryParticipantChoice: null,
            primaryParticipantCpf: '',
            resolvingPrimaryParticipant: false,
            participantsConfirmed: false,
            cartConfirmed: false
        }
    },

    computed: {
        // get global variables
        ...mapState( ['booking_date', 'start_time', 'end_time', 'booking_end_date', 'booked_date_server']),

        selectedTicket() {
            if (!Array.isArray(this.tickets) || this.tickets.length === 0) {
                return null;
            }
            if (typeof this.selectedTicketIndex !== 'number') {
                return null;
            }
            return this.tickets[this.selectedTicketIndex] || null;
        },

        currentUserFirstName() {
            const user = this.getCurrentUser();
            const name = (user && user.name) ? String(user.name) : '';
            if (!name) {
                return 'você';
            }
            return name.split(' ')[0];
        },

        useMultiParticipantCheckout() {
            if (!this.login_user_id) {
                return false;
            }
            if ((this.is_customer || 0) <= 0) {
                return false;
            }
            if ((this.is_mercadopago || 0) <= 0) {
                return false;
            }
            return true;
        },

        courtesyTaxAmount() {
            if (!this.tickets || !this.tickets.length || !this.quantity || !this.quantity.length) {
                return 0;
            }

            let totalTax = 0;
            this.tickets.forEach((ticket, index) => {
                const quantity = parseFloat(this.quantity[index]) || 0;
                if (quantity <= 0) {
                    return;
                }

                const segmentData = this.segmentPriceAdjustments ? this.segmentPriceAdjustments[index] : null;
                let ticketPrice = parseFloat(ticket.price) || 0;

                if (segmentData && segmentData.priceReplaced && segmentData.finalPrice) {
                    ticketPrice = parseFloat(segmentData.finalPrice) || 0;
                } else if (segmentData && segmentData.adjustment) {
                    ticketPrice += parseFloat(segmentData.adjustment) || 0;
                }

                const base = quantity * ticketPrice;
                const gross = parseFloat(this.total_price[index]) || 0;
                const tax = Math.max(0, gross - base);

                totalTax += tax;
            });

            return parseFloat(totalTax.toFixed(2));
        },

        courtesyTicketsPayload() {
            const payload = [];

            if (!this.tickets || !this.tickets.length || !this.quantity || !this.quantity.length) {
                return payload;
            }

            this.tickets.forEach((ticket, index) => {
                const quantity = parseInt(this.quantity[index] || 0, 10) || 0;
                if (quantity <= 0 || !ticket || !ticket.id) {
                    return;
                }

                const segmentData = this.segmentPriceAdjustments ? this.segmentPriceAdjustments[index] : null;
                let ticketPrice = parseFloat(ticket.price) || 0;

                if (segmentData && segmentData.priceReplaced && segmentData.finalPrice) {
                    ticketPrice = parseFloat(segmentData.finalPrice) || 0;
                } else if (segmentData && segmentData.adjustment) {
                    ticketPrice += parseFloat(segmentData.adjustment) || 0;
                }

                payload.push({
                    ticket_id: parseInt(ticket.id, 10),
                    quantity: quantity,
                    unit_price: parseFloat(ticketPrice.toFixed(2))
                });
            });

            return payload;
        },

        orderTaxTotal() {
            return parseFloat(this.courtesyTaxAmount) || 0;
        },

        orderSubtotal() {
            const total = parseFloat(this.total) || 0;
            const tax = parseFloat(this.orderTaxTotal) || 0;
            return Math.max(0, total - tax);
        },

        overallProgress() {
            if (!this.useMultiParticipantCheckout) {
                return 100;
            }

            let steps = 0;
            let done = 0;

            steps += 1;
            if (this.participantsConfirmed) {
                done += 1;
            }

            steps += 1;
            if (this.cartConfirmed) {
                done += 1;
            }

            steps += 1;
            if (this.paymentConfirmed) {
                done += 1;
            }

            return Math.round((done / steps) * 100);
        },

        participantsForCheckout() {
            if (!this.useMultiParticipantCheckout) {
                return [];
            }
            return this.participants.map((p) => ({
                user_id: p.user_id,
                segment_selections: p.segment_selections || {},
                kit_variations: p.kit_variations || {},
            }));
        },

        primaryParticipant() {
            if (!Array.isArray(this.participants) || this.participants.length === 0) {
                return null;
            }
            return this.participants[0] || null;
        },

        extraParticipants() {
            if (!Array.isArray(this.participants) || this.participants.length <= 1) {
                return [];
            }
            return this.participants.slice(1);
        },

        participantsReadyForPayment() {
            if (!this.useMultiParticipantCheckout) {
                return true;
            }
            if (!this.login_user_id) {
                return false;
            }
            if (!this.selectedTicket) {
                return false;
            }
            if (!this.primaryParticipantChoice) {
                return false;
            }
            if (!this.primaryParticipant) {
                return false;
            }
            if (!Array.isArray(this.participants) || this.participants.length === 0) {
                return false;
            }
            if (this.isGroupSale && this.requiresParticipantsCount) {
                return false;
            }
            if (this.isCourtesyCodeRequired() && this.requiresCourtesyCodes) {
                return false;
            }
            if (this.requiresSegmentSelections) {
                return false;
            }
            if (this.requiresKitSelections) {
                return false;
            }
            return true;
        },
    },

   
    methods: {
        // update global variables
        ...mapMutations(['add', 'update']),

        generateInstallments(maxInstallments) {
            const options = [];
            for (let i = 1; i <= maxInstallments; i++) {
                options.push({
                    value: i,
                    label: i === 1 ? '1x sem juros' : `${i}x ${i <= 6 ? 'sem juros' : 'com juros'}`
                });
            }
            return options;
        },

        getCurrentUser() {
            return window.currentUser || null;
        },

        formatCpf(value) {
            const digits = String(value || '').replace(/\D/g, '');
            if (digits.length !== 11) {
                return value;
            }
            return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
        },

        getJsonHeaders() {
            return {
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                'X-Requested-With': 'XMLHttpRequest',
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            };
        },

        resetMultiCheckoutFlowState() {
            this.activeCheckoutSection = 'tickets';
            this.showAddParticipantForm = false;
            this.showPaymentForm = false;
            this.primaryParticipantChoice = null;
            this.primaryParticipantCpf = '';
            this.participants = [];
            this.courtesyCodesByUserId = {};
            this.requiresCourtesyCodes = false;
            this.participantsBaseTotalsByUserId = {};
            this.checkoutOrderId = null;
            this.requiresSegmentSelections = false;
            this.requiresKitSelections = false;
            this.isGroupSale = false;
            this.requiredParticipantsCount = null;
            this.requiresParticipantsCount = false;
            this.participantsConfirmed = false;
            this.cartConfirmed = false;
            this.canAddParticipant = true;
        },

        selectSingleTicket(index) {
            const currentQuantities = Array.isArray(this.quantity) ? this.quantity.map(q => parseInt(q || 0, 10)) : [];
            const currentTotal = currentQuantities.reduce((acc, q) => acc + (isNaN(q) ? 0 : q), 0);
            const isSameTicket = (typeof this.selectedTicketIndex === 'number' && this.selectedTicketIndex === index);
            const isToggleOff = isSameTicket && currentTotal > 0 && (currentQuantities[index] || 0) > 0;

            if (this.useMultiParticipantCheckout && isToggleOff) {
                const next = [];
                for (let i = 0; i < this.tickets.length; i++) {
                    next[i] = 0;
                }
                this.quantity = next;
                this.selectedTicketIndex = null;
                this.checkoutFlowStarted = false;
                this.resetMultiCheckoutFlowState();
                this.totalPrice();
                this.orderTotal();
                this.refreshCheckoutPrepare();
                return;
            }

            const ticketChanged = this.useMultiParticipantCheckout && this.checkoutFlowStarted && typeof this.selectedTicketIndex === 'number' && this.selectedTicketIndex !== index;

            this.selectedTicketIndex = index;
            this.showPaymentForm = false;
            const next = [];
            for (let i = 0; i < this.tickets.length; i++) {
                next[i] = 0;
            }
            next[index] = 1;
            this.quantity = next;

            if (this.useMultiParticipantCheckout) {
                if (!this.checkoutFlowStarted || ticketChanged) {
                    this.resetMultiCheckoutFlowState();
                    this.checkoutFlowStarted = true;
                }
                this.activeCheckoutSection = 'participants';
            }

            this.totalPrice();
            this.orderTotal();
            this.refreshCheckoutPrepare();
        },

        startMultiCheckoutFlow() {
            if (!this.useMultiParticipantCheckout) {
                return;
            }

            if (this.checkoutFlowStarted) {
                this.activeCheckoutSection = 'participants';
                return;
            }

            this.checkoutFlowStarted = true;
            this.activeCheckoutSection = 'participants';
            this.showAddParticipantForm = false;
            this.showPaymentForm = false;
            this.primaryParticipantChoice = null;
            this.primaryParticipantCpf = '';
            this.participants = [];
            this.courtesyCodesByUserId = {};
            this.requiresCourtesyCodes = false;
            this.participantsBaseTotalsByUserId = {};
            this.checkoutOrderId = null;
            this.requiresSegmentSelections = false;
            this.requiresKitSelections = false;
            this.isGroupSale = false;
            this.requiredParticipantsCount = null;
            this.requiresParticipantsCount = false;
            this.participantsConfirmed = false;
            this.cartConfirmed = false;

            if (typeof this.selectedTicketIndex !== 'number') {
                this.selectedTicketIndex = 0;
            }
            this.selectSingleTicket(this.selectedTicketIndex);
            this.showAddParticipantForm = false;
        },

        onPrimaryChoiceClick(choice) {
            if (!this.useMultiParticipantCheckout) {
                return;
            }

            if (choice !== 'self' && choice !== 'other') {
                return;
            }

            if (this.primaryParticipantChoice === choice) {
                this.primaryParticipantChoice = null;
                this.primaryParticipantCpf = '';
                this.showPaymentForm = false;
                this.participantsConfirmed = false;
                this.cartConfirmed = false;
                if (Array.isArray(this.participants) && this.participants.length > 0) {
                    this.participants = this.participants.slice(1);
                }
                return;
            }

            if (choice === 'self') {
                this.choosePrimarySelf();
            } else {
                this.choosePrimaryOther();
            }
        },

        choosePrimarySelf() {
            if (!this.useMultiParticipantCheckout) {
                return;
            }

            if (this.primaryParticipantChoice === 'self' && this.primaryParticipant && String(this.primaryParticipant.user_id) === String(this.login_user_id)) {
                return;
            }

            this.primaryParticipantChoice = 'self';
            this.primaryParticipantCpf = '';
            this.showPaymentForm = false;
            this.showAddParticipantForm = false;
            this.participantsConfirmed = false;
            this.cartConfirmed = false;

            const user = this.getCurrentUser();
            const nextPrimary = {
                user_id: this.login_user_id,
                name: user && user.name ? user.name : null,
                social_name: user && user.social_name ? user.social_name : null,
                document: user && user.document ? user.document : null,
                segment_selections: {},
                kit_variations: {},
            };

            const remaining = (this.participants || []).filter((p) => String(p.user_id) !== String(this.login_user_id));
            this.participants = [nextPrimary, ...remaining];

            this.validateParticipantsKit();
            this.refreshCheckoutPrepare();
        },

        choosePrimaryOther() {
            if (!this.useMultiParticipantCheckout) {
                return;
            }

            if (this.primaryParticipantChoice === 'other') {
                return;
            }

            this.primaryParticipantChoice = 'other';
            this.primaryParticipantCpf = '';
            this.showPaymentForm = false;
            this.showAddParticipantForm = false;
            this.participantsConfirmed = false;
            this.cartConfirmed = false;

            if (Array.isArray(this.participants) && this.participants.length > 0) {
                this.participants = this.participants.slice(1);
            }
        },

        async setPrimaryParticipantByCpf() {
            if (!this.useMultiParticipantCheckout) {
                return;
            }
            if (!this.primaryParticipantCpf) {
                return;
            }

            const cpfDigits = String(this.primaryParticipantCpf).replace(/\D/g, '');
            if (cpfDigits.length !== 11) {
                this.showCriticalError('CPF inválido', 'Informe um CPF válido com 11 dígitos.', 'error');
                return;
            }

            this.resolvingPrimaryParticipant = true;
            this.showPaymentForm = false;
            try {
                const payload = {
                    event_id: this.event.id,
                    cpf: cpfDigits,
                };

                const res = await axios.post(route('eventmie.bookings_participants_resolve'), payload, {
                    headers: {
                        ...this.getJsonHeaders()
                    }
                });

                if (!res.data || !res.data.status || !res.data.participant) {
                    throw new Error('Falha ao resolver participante');
                }

                const participant = res.data.participant;
                const remaining = (this.participants || []).filter((p) => String(p.user_id) !== String(participant.id));
                this.participants = [
                    {
                        user_id: participant.id,
                        name: participant.name,
                        social_name: participant.social_name,
                        document: participant.document,
                        segment_selections: {},
                        kit_variations: {},
                    },
                    ...remaining
                ];

                this.primaryParticipantCpf = '';
                this.participantsConfirmed = false;
                this.cartConfirmed = false;
                this.validateParticipantsKit();
                await this.refreshCheckoutPrepare();
                this.showAddParticipantForm = false;
            } catch (error) {
                const message = error?.response?.data?.message || error?.message || 'Erro ao definir participante';
                this.showCriticalError('Participante', message, 'error', error?.response?.data?.redirect_profile || false);
            } finally {
                this.resolvingPrimaryParticipant = false;
            }
        },

        toggleCheckoutSection(section) {
            if (!section) {
                return;
            }

            if (this.activeCheckoutSection === section) {
                this.activeCheckoutSection = 'tickets';
                return;
            }

            this.activeCheckoutSection = section;
        },

        toggleAddParticipantForm() {
            this.showAddParticipantForm = !this.showAddParticipantForm;
        },

        goToCartSection() {
            if (!this.participantsReadyForPayment) {
                return;
            }
            this.activeCheckoutSection = 'cart';
        },

        confirmParticipants() {
            if (!this.participantsReadyForPayment) {
                return;
            }

            this.participantsConfirmed = true;
            this.cartConfirmed = false;
            this.showPaymentForm = false;
            this.activeCheckoutSection = 'cart';

            this.$nextTick(() => {
                const element = this.$refs.checkoutCartCard;
                if (!element) {
                    return;
                }

                setTimeout(() => {
                    this.scrollToElementWithOffset(element, 120);
                }, 250);
            });
        },

        scrollToElementWithOffset(element, offset) {
            if (!element || typeof element.getBoundingClientRect !== 'function') {
                return;
            }

            const top = element.getBoundingClientRect().top + window.pageYOffset - (parseInt(offset, 10) || 0);
            window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
        },

        confirmCart() {
            if (!this.participantsConfirmed) {
                return;
            }

            this.cartConfirmed = true;
            this.activeCheckoutSection = 'payment';
            if (this.useMultiParticipantCheckout) {
                this.openPaymentForm();
            }
        },

        editStep(step) {
            if (!this.useMultiParticipantCheckout) {
                return;
            }
            if (!step) {
                return;
            }

            if (step === 'participants') {
                this.participantsConfirmed = false;
                this.cartConfirmed = false;
                this.showPaymentForm = false;
                this.activeCheckoutSection = 'participants';
                return;
            }

            if (step === 'cart') {
                this.cartConfirmed = false;
                this.showPaymentForm = false;
                this.activeCheckoutSection = 'cart';
                return;
            }
        },

        goToPaymentSection() {
            if (!this.participantsReadyForPayment) {
                return;
            }
            this.activeCheckoutSection = 'payment';
            if (this.useMultiParticipantCheckout) {
                this.openPaymentForm();
            }
        },

        initializeMultiParticipantCheckout() {
            if (!this.useMultiParticipantCheckout) {
                return;
            }

            if (!Array.isArray(this.participants) || this.participants.length === 0) {
                const user = this.getCurrentUser();
                this.participants = [
                    {
                        user_id: this.login_user_id,
                        name: user && user.name ? user.name : null,
                        document: user && user.document ? user.document : null,
                        segment_selections: {},
                        kit_variations: {},
                    }
                ];
            }

            this.participants.forEach((p) => {
                if (!p.kit_variations) {
                    this.$set(p, 'kit_variations', {});
                }
                if (!p.segment_selections) {
                    this.$set(p, 'segment_selections', {});
                }
            });

            if (typeof this.selectedTicketIndex !== 'number') {
                this.selectedTicketIndex = 0;
            }

            this.selectSingleTicket(this.selectedTicketIndex || 0);
        },

        validateParticipantsKit() {
            this.participantKitErrors = {};
            let isValid = true;

            if (!this.useMultiParticipantCheckout) {
                return true;
            }
            if (!this.event || !this.event.kit_id) {
                return true;
            }
            if (!Array.isArray(this.kitVariations) || this.kitVariations.length === 0) {
                return true;
            }

            this.participants.forEach((participant, pIndex) => {
                this.kitVariations.forEach((kitItem, kitIndex) => {
                    const key = `${pIndex}_${kitIndex}`;
                    const selectedValue = participant && participant.kit_variations ? participant.kit_variations[kitIndex] : null;
                    const selectableCount = typeof kitItem.selectable_options_count !== 'undefined'
                        ? parseInt(kitItem.selectable_options_count, 10)
                        : (kitItem.options || []).filter(opt => (opt && opt.stock > 0)).length;

                    if (kitItem.is_required && selectableCount <= 0) {
                        this.$set(this.participantKitErrors, key, `${kitItem.name} está esgotado no momento`);
                        isValid = false;
                        return;
                    }

                    if (kitItem.is_required && (!selectedValue || selectedValue === '')) {
                        this.$set(this.participantKitErrors, key, `${kitItem.name} é obrigatório`);
                        isValid = false;
                    }
                });
            });

            return isValid;
        },

        onParticipantSegmentSelectionChanged(selections, participantIndex) {
            if (!this.participants[participantIndex]) {
                return;
            }
            this.showPaymentForm = false;
            this.$set(this.participants[participantIndex], 'segment_selections', selections || {});
            this.refreshCheckoutPrepare();
        },

        onParticipantPriceAdjusted(payload, participantIndex) {
            this.showPaymentForm = false;
            this.refreshCheckoutPrepare();
        },

        onParticipantKitChanged(participantIndex) {
            this.showPaymentForm = false;
            this.validateParticipantsKit();
            this.refreshCheckoutPrepare();
        },

        async addParticipantByCpf() {
            if (!this.useMultiParticipantCheckout) {
                return;
            }
            if (!this.newParticipantCpf) {
                return;
            }

            const cpfDigits = String(this.newParticipantCpf).replace(/\D/g, '');
            if (cpfDigits.length !== 11) {
                this.showCriticalError('CPF inválido', 'Informe um CPF válido com 11 dígitos.', 'error');
                return;
            }

            if (!this.selectedTicket) {
                this.showCriticalError('Ingresso', 'Selecione um ingresso antes de adicionar participantes.', 'warning');
                return;
            }

            if (!this.canAddParticipant) {
                return;
            }

            this.addingParticipant = true;
            this.showPaymentForm = false;
            try {
                const payload = {
                    event_id: this.event.id,
                    cpf: cpfDigits,
                };

                const res = await axios.post(route('eventmie.bookings_participants_resolve'), payload, {
                    headers: {
                        ...this.getJsonHeaders()
                    }
                });

                if (!res.data || !res.data.status || !res.data.participant) {
                    throw new Error('Falha ao resolver participante');
                }

                const participant = res.data.participant;
                const alreadyExists = this.participants.some(p => String(p.user_id) === String(participant.id));
                if (alreadyExists) {
                    this.showCriticalError('Participante', 'Este participante já foi adicionado.', 'warning');
                    return;
                }

                this.participants.push({
                    user_id: participant.id,
                    name: participant.name,
                    social_name: participant.social_name,
                    document: participant.document,
                    segment_selections: {},
                    kit_variations: {},
                });

                this.newParticipantCpf = '';
                this.showAddParticipantForm = false;
                this.participantsConfirmed = false;
                this.cartConfirmed = false;
                this.validateParticipantsKit();
                await this.refreshCheckoutPrepare();

                this.showAddParticipantForm = true;
            } catch (error) {
                const message = error?.response?.data?.message || error?.message || 'Erro ao adicionar participante';
                this.showCriticalError('Participante', message, 'error', error?.response?.data?.redirect_profile || false);
            } finally {
                this.addingParticipant = false;
            }
        },

        async openPaymentForm() {
            if (!this.useMultiParticipantCheckout) {
                this.payment_method = 2;
                return;
            }

            if (!this.primaryParticipantChoice || !this.primaryParticipant) {
                this.showCriticalError('Checkout', 'Escolha quem será o participante principal antes de continuar.', 'warning');
                return;
            }

            await this.refreshCheckoutPrepare();

            if (this.isGroupSale && this.requiresParticipantsCount) {
                const n = this.requiredParticipantsCount ? parseInt(this.requiredParticipantsCount, 10) : null;
                const current = Array.isArray(this.participants) ? this.participants.length : 0;
                const label = n ? `Este ingresso exige exatamente ${n} participante(s). (Atual: ${current})` : 'Quantidade de participantes inválida para este ingresso.';
                this.showCriticalError('Checkout', label, 'warning');
                return;
            }

            if (this.isCourtesyCodeRequired() && this.requiresCourtesyCodes) {
                this.showCriticalError('Checkout', 'Aplique um código de cortesia para todos os participantes antes de continuar.', 'warning');
                return;
            }

            if (this.requiresSegmentSelections) {
                this.showCriticalError('Checkout', 'Selecione as opções obrigatórias (modalidade/categoria) para todos os participantes antes de continuar.', 'warning');
                return;
            }

            if (this.requiresKitSelections) {
                this.showCriticalError('Checkout', 'Selecione as opções obrigatórias do kit para todos os participantes antes de continuar.', 'warning');
                return;
            }

            this.showPaymentForm = true;
            this.payment_method = 2;
            this.$nextTick(() => {
                this.scrollToMercadoPagoForm();
            });
        },

        removeParticipant(index) {
            if (!this.useMultiParticipantCheckout) {
                return;
            }
            if (index <= 0) {
                return;
            }
            this.showPaymentForm = false;
            this.participantsConfirmed = false;
            this.cartConfirmed = false;
            this.participants.splice(index, 1);
            this.validateParticipantsKit();
            this.refreshCheckoutPrepare();
        },

        async refreshCheckoutPrepare() {
            if (!this.useMultiParticipantCheckout) {
                return;
            }
            if (!this.selectedTicket || !this.event || !this.event.id) {
                return;
            }
            if (!Array.isArray(this.participants) || this.participants.length === 0) {
                return;
            }

            this.validateParticipantsKit();

            this.checkoutPreparing = true;
            try {
                const urlToken = new URLSearchParams(window.location.search).get('token');
                const payload = {
                    event_id: this.event.id,
                    ticket_id: this.selectedTicket.id,
                    participants: this.participantsForCheckout,
                    addon_selections: this.getAddonSelectionsPayload(),
                    courtesy_codes: this.courtesyCodesByUserId,
                };

                if (urlToken) {
                    payload.token = urlToken;
                }

                const response = await axios.post(route('eventmie.bookings_checkout_prepare'), payload, {
                    headers: {
                        ...this.getJsonHeaders()
                    }
                });

                if (!response.data || !response.data.status) {
                    throw new Error(response?.data?.message || 'Falha ao preparar checkout');
                }

                this.checkoutOrderId = response.data.order_id;
                this.total = parseFloat(response.data.total);
                this.canAddParticipant = !!response.data.can_add_participant;
                this.isGroupSale = !!response.data.is_group_sale;
                this.requiredParticipantsCount = response.data.required_participants_count ? parseInt(response.data.required_participants_count, 10) : null;
                this.requiresParticipantsCount = !!response.data.requires_participants_count;
                this.requiresSegmentSelections = !!response.data.requires_segment_selections;
                this.requiresKitSelections = !!response.data.requires_kit_selections;
                this.requiresCourtesyCodes = !!response.data.requires_courtesy_codes;

                const base = Array.isArray(response.data.participants_base) ? response.data.participants_base : [];
                const map = {};
                base.forEach((row) => {
                    if (!row || !row.user_id) {
                        return;
                    }
                    map[String(row.user_id)] = row;
                });
                this.participantsBaseTotalsByUserId = map;
            } catch (error) {
                const data = error?.response?.data;
                let message = data?.message || error?.message || 'Erro ao preparar checkout';
                if (data && data.errors && typeof data.errors === 'object') {
                    const first = Object.values(data.errors)
                        .flat()
                        .filter(v => !!v)
                        .shift();
                    if (first) {
                        message = String(first);
                    }
                }

                this.showCriticalError('Checkout', message, 'error', data?.redirect_profile || false);
            } finally {
                this.checkoutPreparing = false;
            }
        },

        // reset form and close modal
        close: function () {    
            this.price          = null;
            this.quantity       = [];
            this.total_price    = [];
            
            this.add({
                booking_date        : null,
                booked_date_server  : null,
                booking_end_date    : null,
                start_time          : null,
                end_time            : null,
            })
            
            
            this.openModal      = false;
        },

        async bookTickets(){
            console.log('=== BOOK TICKETS INICIADO ===');
            console.log('payment_method:', this.payment_method);
            console.log('total:', this.total);
            console.log('event_status:', this.event ? this.event.event_status : 'undefined');

            // 🔒 VALIDAÇÃO CRÍTICA: CPF/CNPJ obrigatório antes de qualquer coisa
            if (!this.validateUserDocument()) {
                this.disable = false;
                return; // Método já exibe toast e redireciona
            }

            // VALIDAÇÃO CRÍTICA: Verificar se código de cortesia é obrigatório
            if (this.isCourtesyCodeRequired() && !this.hasValidCourtesyCode()) {
                this.disable = false;
                this.showNotification('error', 'Este evento está em modo cortesia. É obrigatório aplicar um código de cortesia válido antes de finalizar a compra.');
                return;
            }

            // Validar checkboxes de termos e regulamento
            if (!this.acceptTerms) {
                this.disable = false;
                this.showNotification('error', 'Você deve aceitar os Termos de Serviço e Política de Privacidade para continuar');
                return;
            }

            if (!this.acceptRegulamento) {
                this.disable = false;
                this.showNotification('error', 'Você deve confirmar que leu e aceita o regulamento do evento para continuar');
                return;
            }

            // Validar classificações de segmento se necessário
            if (!this.useMultiParticipantCheckout && this.event.segment_id && !this.validateSegmentSelections()) {
                this.disable = false;
                this.showNotification('error', 'Por favor, preencha todas as classificações obrigatórias');
                return;
            }

            if (this.useMultiParticipantCheckout && this.event.segment_id && !this.validateParticipantsSegmentSelections()) {
                this.disable = false;
                this.showNotification('error', 'Por favor, preencha todas as classificações obrigatórias');
                return;
            }

            if (this.useMultiParticipantCheckout && this.event.kit_id && !this.validateParticipantsKit()) {
                this.disable = false;
                this.showNotification('error', 'Selecione as opções obrigatórias do kit para continuar.');
                return;
            }

            // 🔒 NOVO: Validar limites de segmento se habilitado
            if (!this.useMultiParticipantCheckout && this.enable_limit_validation && !this.validateAllLimits()) {
                this.disable = false;
                this.showNotification('error', 'Algumas seleções excedem os limites disponíveis. Verifique as mensagens de validação.');
                return;
            }

            // 🛡️ VALIDAÇÃO OBRIGATÓRIA: Kit deve ser selecionado para eventos com kit
            if (!this.useMultiParticipantCheckout && this.event.kit_id) {
                const hasRequiredKitItems = (this.kitVariations || []).some(it => !!it.is_required);
                
                // Somente bloquear por "carregamento" se houver itens obrigatórios
                if (hasRequiredKitItems && this.kitVariations.length === 0) {
                    this.disable = false;
                    if (this.kitVariationsLoading) {
                        this.showNotification('error', 'Aguarde o carregamento das opções do kit');
                    } else {
                        this.showNotification('error', this.kitVariationsLoadError || 'Opções do kit indisponíveis no momento');
                    }
                    return;
                }
                
                // Verificar se todas as variações obrigatórias foram selecionadas
                if (hasRequiredKitItems && !this.validateAllKitVariations()) {
                    this.disable = false;
                    this.showNotification('error', 'Por favor, selecione as opções obrigatórias do kit');
                    return;
                }
            }

            // prepare form data for post request
            this.disable = true;

            if (this.useMultiParticipantCheckout && !this.showPaymentForm && this.total > 0) {
                this.disable = false;
                await this.openPaymentForm();
                return;
            }

            // Se for ingresso gratuito, processar direto sem pagamento
            if(this.total <= 0) {
                console.log('Processando como ingresso gratuito');
                // Processar como ingresso gratuito
                this.processFreeTickets();
                return;
            }

            // Se for Mercado Pago, processar pagamento
            if(this.payment_method == 2) {
                console.log('Mercado Pago selecionado - processando pagamento');

                if (this.useMultiParticipantCheckout) {
                    this.disable = true;
                    await this.refreshCheckoutPrepare();

                    if (!this.checkoutOrderId) {
                        this.disable = false;
                        return;
                    }

                    const selectedTicket = this.selectedTicket;
                    this.$nextTick(() => {
                        if (this.$refs.mercadoPagoCheckout) {
                            this.$refs.mercadoPagoCheckout.setSelectedTicket(selectedTicket);
                            if (this.selectedAddonIds && this.selectedAddonIds.length > 0) {
                                this.$refs.mercadoPagoCheckout.setAddonSelections(this.getAddonSelectionsPayload());
                            }
                            this.$refs.mercadoPagoCheckout.processPayment();
                        }
                    });

                    this.disable = false;
                    return;
                }
                
                // 🎯 VALIDAR E COLETAR SELEÇÕES DE SEGMENTO ANTES DE PROCESSAR
                if (this.event.segment_id && !this.validateSegmentSelections()) {
                    this.disable = false;
                    this.showNotification('error', 'Por favor, preencha todas as classificações obrigatórias.');
                    return;
                }
                
                // Find the selected ticket (the one with quantity > 0)
                let selectedTicket = null;
                for (let i = 0; i < this.tickets.length; i++) {
                    if (this.quantity[i] && parseInt(this.quantity[i]) > 0) {
                        selectedTicket = this.tickets[i];
                        console.log('Ticket selecionado:', selectedTicket);
                        break;
                    }
                }
                
                console.log('🎯 Seleções de segmento coletadas:', this.segmentSelections);
                
                // Aguardar próximo tick para garantir que o componente foi renderizado
                this.$nextTick(() => {
                    // Chamar método de processamento do componente MercadoPagoCheckout
                    if(this.$refs.mercadoPagoCheckout) {
                        this.$refs.mercadoPagoCheckout.setSelectedTicket(selectedTicket);
                        
                        // 📦 ADICIONADO: Passar variações do kit para o MercadoPagoCheckout
                        if (this.event.kit_id && this.selectedKitVariations) {
                            this.$refs.mercadoPagoCheckout.setKitVariations(this.selectedKitVariations);
                        }
                        
                        // 🎯 ADICIONADO: Passar seleções de segmento para o MercadoPagoCheckout
                        if (this.event.segment_id && this.segmentSelections) {
                            console.log('🎯 Passando segment_selections para MercadoPagoCheckout:', this.segmentSelections);
                            this.$refs.mercadoPagoCheckout.setSegmentSelections(this.segmentSelections);
                        }

                        if (this.selectedAddonIds && this.selectedAddonIds.length > 0) {
                            this.$refs.mercadoPagoCheckout.setAddonSelections(this.getAddonSelectionsPayload());
                        }
                        
                        this.$refs.mercadoPagoCheckout.processPayment();
                    } else {
                        console.error('MercadoPagoCheckout ref não encontrado');
                    }
                });
                this.disable = false;
                return;
            }

            console.log('Enviando para backend:', route('eventmie.bookings_book_tickets'));
            let post_url = route('eventmie.bookings_book_tickets');
            let post_data = new FormData(this.$refs.form);

            this.applyMultiParticipantTicketQuantityToFormData(post_data);

            const urlToken = new URLSearchParams(window.location.search).get('token');
            if (urlToken) {
                post_data.set('token', urlToken);
            }
            
            // Adicionar dados de segmentação se existirem
            if (this.event.segment_id) {
                const segmentData = this.getSegmentDataForBooking();
                post_data.append('segment_data', JSON.stringify(segmentData));
                
                // 🎯 CRÍTICO: Adicionar segment_selections para pagamento normal também
                const segmentSelectionsPayload = this.getSegmentSelectionsPayloadForRequest();

                if (segmentSelectionsPayload && Object.keys(segmentSelectionsPayload).length > 0) {
                    console.log('Adicionando segment_selections ao FormData (pagamento normal):', segmentSelectionsPayload);
                    post_data.append('segment_selections', JSON.stringify(segmentSelectionsPayload));
                }
            }
            
            // CRÍTICO: Adicionar dados de kit se existirem
            if (this.event.kit_id) {
                const kitSelectionsPayload = this.getKitSelectionsPayloadForRequest();
                if (kitSelectionsPayload && ((Array.isArray(kitSelectionsPayload) && kitSelectionsPayload.length > 0) || (!Array.isArray(kitSelectionsPayload) && Object.keys(kitSelectionsPayload).length > 0))) {
                    console.log('Adicionando kit_selections ao FormData:', kitSelectionsPayload);
                    post_data.append('kit_selections', JSON.stringify(kitSelectionsPayload));
                }
            }

            if (this.selectedAddonIds && this.selectedAddonIds.length > 0) {
                post_data.append('addon_selections', JSON.stringify(this.getAddonSelectionsPayload()));
            }
            
            console.log('Enviando requisição para:', post_url);
            console.log('FormData preparado - iniciando axios.post');
            
            axios.post(post_url, post_data)
            .then(res => {
                console.log('Resposta recebida:', res.data);
                
                if(res.data.status && res.data.message != ''  && typeof(res.data.message) != "undefined") {
                   
                    // hide loader
                    Swal.hideLoading();

                    // close popup
                    this.close();
                    this.showNotification('success', res.data.message);
                    
                }
                else if(!res.data.status && res.data.message != '' && res.data.url != ''  && typeof(res.data.url) != "undefined"){
                    
                    // hide loader
                    Swal.hideLoading();
                    
                    // close popup
                    this.close();
                    this.showNotification('error', res.data.message);
                    
                    setTimeout(() => {
                        window.location.href = res.data.url;    
                    }, 1000);
                }
                // 🔒 NOVO: Tratamento específico para erros de validação críticos (CPF, etc.)
                else if(!res.data.status && res.data.message) {
                    // hide loader
                    Swal.hideLoading();
                    
                    // Determinar tipo de toast baseado na resposta
                    const toastType = res.data.toast_type || 'error';
                    const toastTitle = res.data.toast_title || 'Erro na Validação';
                    
                    // Exibir toast com título e mensagem
                    this.showCriticalError(toastType, toastTitle, res.data.message);
                    
                    // Se deve redirecionar para perfil (CPF inválido)
                    if (res.data.redirect_profile) {
                        setTimeout(() => {
                            // Redirecionar para página de perfil do usuário
                            window.location.href = '/profile';
                        }, 3000);
                    }
                    
                    // Não fechar o modal para permitir correção
                    return;
                }

                // Mercado Pago payment method
                if(res.data.payment_method == 'mercadopago' && res.data.status) {
                    
                    // hide loader
                    Swal.hideLoading();

                    // close popup
                    this.close();
                    
                    // Mostrar formulário de Mercado Pago
                    this.scrollToMercadoPagoForm();
                }

                if(res.data.url != '' && res.data.status  && typeof(res.data.url) != "undefined") {
                    
                    // hide loader
                    Swal.hideLoading();

                    setTimeout(() => {
                        window.location.href = res.data.url;    
                    }, 1000);
                }

                if(!res.data.status && res.data.message != ''  && typeof(res.data.message) != "undefined") {
                   
                    // hide loader
                    Swal.hideLoading();

                    // close popup
                    this.close();
                    this.showNotification('error', res.data.message);
                    
                }

            })
            .catch(error => {
                console.error('Erro na requisição:', error);
                console.error('Resposta de erro:', error.response);
                Swal.hideLoading();
                this.disable = false;
                let serrors = Vue.helpers.axiosErrors(error);
                if (serrors.length) {
                    console.log('Erros de validação:', serrors);
                    this.serverValidate(serrors);
                } else if (error.response && error.response.data) {
                    const data = error.response.data;
                    if (data.message) {
                        const toastTitle = data.toast_title || 'Erro de Validação';
                        const toastType = data.toast_type || 'error';
                        this.showCriticalError(toastTitle, data.message, toastType, !!data.redirect_profile);
                        if (data.redirect_profile) {
                            setTimeout(() => {
                                window.location.href = '/profile';
                            }, 3000);
                        }
                    } else {
                        this.showNotification('error', 'Erro na comunicação com o servidor');
                    }
                }
            });
        },

        scrollToMercadoPagoForm() {
            // Scroll para o formulário
            const element = document.querySelector('.mercadopago-checkout-container');
            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        },

        async processFreeTickets() {
            console.log('=== PROCESSANDO INGRESSOS GRATUITOS ===');
            console.log('Total:', this.total);
            console.log('Courtesy Discount:', this.courtesyDiscount);

            if (this.useMultiParticipantCheckout && this.event && this.event.kit_id && !this.validateParticipantsKit()) {
                this.showNotification('error', 'Selecione as opções obrigatórias do kit para continuar.');
                return;
            }

            if (this.useMultiParticipantCheckout) {
                this.disable = true;

                try {
                    if (!this.checkoutOrderId) {
                        await this.refreshCheckoutPrepare();
                    }

                    if (!this.checkoutOrderId) {
                        throw new Error('Pedido não encontrado. Atualize a página e tente novamente.');
                    }

                    const payload = {
                        order_id: this.checkoutOrderId,
                        event_id: this.event.id,
                        ticket_id: this.selectedTicket.id,
                        participants: this.participantsForCheckout,
                        addon_selections: this.getAddonSelectionsPayload(),
                        courtesy_codes: this.courtesyCodesByUserId,
                        total: parseFloat(this.total)
                    };

                    const urlToken = new URLSearchParams(window.location.search).get('token');
                    if (urlToken) {
                        payload.token = urlToken;
                    }

                    const res = await axios.post(route('eventmie.bookings_checkout_free'), payload, {
                        headers: {
                            ...this.getJsonHeaders()
                        }
                    });

                    Swal.hideLoading();

                    if (res.data && res.data.status) {
                        this.close();
                        this.showNotification('success', res.data.message || 'Pedido confirmado com sucesso!');
                        setTimeout(() => {
                            window.location.href = '/mybookings';
                        }, 2000);
                        return;
                    }

                    this.close();
                    this.showNotification('error', (res.data && res.data.message) ? res.data.message : 'Erro ao finalizar pedido');
                    return;
                } catch (error) {
                    this.disable = false;
                    Swal.hideLoading();

                    let serrors = Vue.helpers.axiosErrors(error);
                    if (serrors.length) {
                        this.serverValidate(serrors);
                    } else if (error.response && error.response.data) {
                        const data = error.response.data;
                        if (data.message) {
                            const toastTitle = data.toast_title || 'Erro de Validação';
                            const toastType = data.toast_type || 'error';
                            this.showCriticalError(toastTitle, data.message, toastType, !!data.redirect_profile);
                            if (data.redirect_profile) {
                                setTimeout(() => {
                                    window.location.href = '/profile';
                                }, 3000);
                            }
                        } else {
                            this.showNotification('error', 'Erro na comunicação com o servidor');
                        }
                    } else {
                        this.showNotification('error', error && error.message ? error.message : 'Erro na comunicação com o servidor');
                    }
                    return;
                } finally {
                    this.disable = false;
                }
            }
            
            // Processar ingressos gratuitos sem pagamento
            let post_url = route('eventmie.bookings_book_tickets');
            let post_data = new FormData(this.$refs.form);

            this.applyMultiParticipantTicketQuantityToFormData(post_data);

            const urlToken = new URLSearchParams(window.location.search).get('token');
            if (urlToken) {
                post_data.set('token', urlToken);
            }
            
            // Adicionar payment_method como 'free' ou 'offline'
            post_data.set('payment_method', 'offline');
            
            // 🎫 ADICIONAR: Dados de cortesia se existirem
            if (this.courtesyDiscount) {
                console.log('Adicionando courtesy_data ao FormData:', this.courtesyDiscount);
                post_data.append('courtesy_data', JSON.stringify(this.courtesyDiscount));
            }
            
            // Adicionar dados de segmentação se existirem
            if (this.event.segment_id) {
                const segmentData = this.getSegmentDataForBooking();
                post_data.append('segment_data', JSON.stringify(segmentData));
                
                // 🎯 CRÍTICO: Adicionar segment_selections para o novo formato
                const segmentSelectionsPayload = this.getSegmentSelectionsPayloadForRequest();

                if (segmentSelectionsPayload && Object.keys(segmentSelectionsPayload).length > 0) {
                    console.log('Adicionando segment_selections ao FormData:', segmentSelectionsPayload);
                    post_data.append('segment_selections', JSON.stringify(segmentSelectionsPayload));
                }
            }
            
            // 📦 CRÍTICO: Adicionar dados de kit se existirem
            if (this.event.kit_id) {
                const kitSelectionsPayload = this.getKitSelectionsPayloadForRequest();
                if (kitSelectionsPayload && ((Array.isArray(kitSelectionsPayload) && kitSelectionsPayload.length > 0) || (!Array.isArray(kitSelectionsPayload) && Object.keys(kitSelectionsPayload).length > 0))) {
                    console.log('Adicionando kit_selections ao FormData:', kitSelectionsPayload);
                    post_data.append('kit_selections', JSON.stringify(kitSelectionsPayload));
                }
            }

            if (this.selectedAddonIds && this.selectedAddonIds.length > 0) {
                post_data.append('addon_selections', JSON.stringify(this.getAddonSelectionsPayload()));
            }
            
            console.log('Enviando requisição para:', post_url);
            console.log('FormData preparado - iniciando axios.post');
            
            axios.post(post_url, post_data)
            .then(res => {
                console.log('=== RESPOSTA RECEBIDA ===');
                console.log('Status HTTP:', res.status);
                console.log('Dados da resposta:', res.data);
                
                // hide loader
                Swal.hideLoading();

                if(res.data.status && res.data.message != '' && typeof(res.data.message) != "undefined") {
                    console.log('✅ Sucesso - fechando modal e mostrando notificação');
                    // close popup
                    this.close();
                    this.showNotification('success', res.data.message);
                    
                    // Redirecionar se houver URL
                    if(res.data.url != '' && typeof(res.data.url) != "undefined") {
                        setTimeout(() => {
                            window.location.href = res.data.url;    
                        }, 1000);
                    }
                } else if(!res.data.status && res.data.message != '') {
                    console.log('❌ Erro retornado pelo servidor:', res.data.message);
                    this.close();
                    this.showNotification('error', res.data.message);
                } else {
                    console.log('⚠️ Resposta inesperada:', res.data);
                    console.log('Status:', res.data.status);
                    console.log('Message:', res.data.message);
                    console.log('Tipo da message:', typeof(res.data.message));
                    
                    // Caso específico do toast "undefined"
                    if (typeof(res.data.message) === "undefined") {
                        console.log('🚨 PROBLEMA: message é undefined - mostrando toast genérico');
                        this.close();
                        this.showNotification('error', 'Erro inesperado no processamento. Verifique os logs do servidor.');
                    } else {
                        this.close();
                        this.showNotification('error', res.data.message || 'Erro desconhecido');
                    }
                }
            })
            .catch(error => {
                console.log('=== ERRO NA REQUISIÇÃO ===');
                console.log('Error object:', error);
                console.log('Response:', error.response);
                console.log('Status:', error.response?.status);
                console.log('Data:', error.response?.data);
                
                this.disable = false;
                Swal.hideLoading();
                let serrors = Vue.helpers.axiosErrors(error);
                if (serrors.length) {
                    console.log('Erros de validação:', serrors);
                    this.serverValidate(serrors);
                } else if (error.response && error.response.data) {
                    const data = error.response.data;
                    if (data.message) {
                        const toastTitle = data.toast_title || 'Erro de Validação';
                        const toastType = data.toast_type || 'error';
                        this.showCriticalError(toastTitle, data.message, toastType, !!data.redirect_profile);
                        if (data.redirect_profile) {
                            setTimeout(() => {
                                window.location.href = '/profile';
                            }, 3000);
                        }
                    } else {
                        this.showNotification('error', 'Erro na comunicação com o servidor');
                    }
                } else {
                    console.log('Erro sem validação específica');
                    this.showNotification('error', 'Erro na comunicação com o servidor');
                }
            });
        },
        

        // validate data on form submit
        validateForm(e) {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    if (this.useMultiParticipantCheckout) {
                        const kitValid = this.validateParticipantsKit();
                        if (!kitValid) {
                            this.disable = false;
                            return;
                        }
                        this.disable = true;
                        this.formSubmit(e);
                        return;
                    }

                    // Validate segment selections
                    const segmentValid = this.validateSegmentSelections();
                    
                    // Validate kit variations
                    const kitVariationsValid = this.validateAllKitVariations();
                    
                    if (segmentValid && kitVariationsValid) {
                        this.disable = true;
                        this.formSubmit(e);
                    } else {
                        this.disable = false;
                        if (!kitVariationsValid) {
                            console.log('Kit variations validation failed');
                        }
                    }
                }
                else{
                    this.disable = false;
                }
            });
        },

        // show server validation errors
        serverValidate(serrors) {
            this.disable = false;
            this.$validator.validateAll().then((result) => {
                this.$validator.errors.add(serrors);
            });
        },

        
        // count total tax
        countTax(price, tax, rate_type, net_price, quantity) {
            
            price           = parseFloat(price).toFixed(2);
            tax             = parseFloat(tax).toFixed(2);
            var total_tax   = parseFloat(quantity * tax).toFixed(2);
            
            
                // in case of percentage
                if(rate_type == 'percent')
                {
                    if(isNaN((price * total_tax)/100))
                        return 0;
                    
                    total_tax = (parseFloat((price*total_tax)/100)).toFixed(2); 

                    if(net_price == 'excluding')
                        return this.currency+' '+total_tax+' ('+tax+'%'+' '+trans('em.exclusive')+')';
                    else
                        return this.currency+' '+total_tax+' ('+tax+'%'+' '+trans('em.inclusive')+')';
                }    

                // for fixed tax
                if(rate_type == 'fixed')
                {
                    if(net_price == 'excluding')
                        return this.currency+' '+total_tax;
                    else
                        return this.currency+' '+total_tax;
                }        
                
            return 0;        
        },

        // count total price
        totalPrice(){
            if(this.quantity != null || this.quantity.length > 0)
            {
                let amount;
                let tax;
                let total_tax ;
                this.quantity.forEach(function(value, key) {
                    total_tax               = 0;
                    this.total_price[key]   = [];
                    
                    // 🎯 USAR PREÇO SUBSTITUÍDO OU ORIGINAL
                    let ticketPrice = parseFloat(this.tickets[key].price) || 0;
                    const segmentData = this.segmentPriceAdjustments[key];
                    
                    
                    if (segmentData && segmentData.priceReplaced && segmentData.finalPrice) {
                        // Se o preço foi substituído por classificação, usar preço final
                        ticketPrice = parseFloat(segmentData.finalPrice) || 0;
                    } else if (segmentData && segmentData.adjustment) {
                        // Se há ajuste aditivo, aplicar sobre preço original
                        const adjustment = parseFloat(segmentData.adjustment) || 0;
                        ticketPrice = (parseFloat(this.tickets[key].price) || 0) + adjustment;
                    }
                    
                    // Garantir que value e ticketPrice são números válidos
                    const quantity = parseFloat(value) || 0;
                    const finalTicketPrice = parseFloat(ticketPrice) || 0;
                    amount = (quantity * finalTicketPrice).toFixed(2);
                    

                    // Sempre definir o total_price para este ticket
                    this.total_price[key] = amount;
                    if(this.tickets[key].taxes.length > 0 && amount > 0) {

                        this.tickets[key].taxes.forEach(function(tax_v, tax_k) {
                                    // in case of percentage
                            if(tax_v.rate_type == 'percent')
                            {
                                // in case of excluding
                                if(!tax_v.net_price || tax_v.net_price == 'excluding')
                                {
                                    tax = isNaN((amount * tax_v.rate)/100) ? 0 : (parseFloat((amount*tax_v.rate)/100)).toFixed(2);

                                    total_tax   =  parseFloat(total_tax) + parseFloat(tax);
                                }
                            }

                            // // in case of percentage
                            if(tax_v.rate_type == 'fixed')
                            {
                                tax   = parseFloat(value *tax_v.rate);
                                
                                // // in case of excluding
                                if(!tax_v.net_price || tax_v.net_price == 'excluding')
                                    total_tax   = parseFloat(total_tax) + parseFloat(tax);

                            }
                            
                        }.bind(this))    
                    }
                    
                    // Calcular preço final com taxas (sem ajuste de segmentação pois já está no amount)
                    this.total_price[key] = (parseFloat(amount) + parseFloat(total_tax)).toFixed(2);
                    
                    
                }.bind(this));
            }
        },

        updateItem() {
            this.$emit('changeItem');
        },

        setDefaultQuantity() {
            // only set default value once
            var _this   = this;
            var promise = new Promise(function(resolve, reject) { 
                // only set default value once
                if(_this.quantity.length == 1) {
                    _this.tickets.forEach(function(value, key) {
                        if(key == 0)
                            _this.quantity[key] = 0;
                        else
                            _this.quantity[key] = 0;
                            
                    }.bind());
                }
                resolve(true);
            }); 

            promise.then(function(successMessage) {
                _this.totalPrice();
                _this.orderTotal();
            }, function(errorMessage) { 
                
            }); 
        },

        // count prise all booked tickets
        orderTotal() {
            if (this.courtesyDiscount && this.courtesyDiscount.final_amount !== undefined) {
                this.total = parseFloat(this.courtesyDiscount.final_amount).toFixed(2);
                return this.total;
            }

            this.total = 0
            
            if(Object.keys(this.total_price).length > 0)
            {
                this.total_price.forEach(function(value, key){
                    const currentTotal = parseFloat(this.total) || 0;
                    const itemValue = parseFloat(value) || 0;
                    console.log(`Adding item ${key}: ${itemValue} to total ${currentTotal}`);
                    this.total = (currentTotal + itemValue).toFixed(2);
                    
                }.bind(this))

                const withAddons = (parseFloat(this.total) + parseFloat(this.addonsTotal() || 0)).toFixed(2);
                this.total = withAddons;
                console.log('Final total calculated:', this.total);
                return this.total;
            }
            console.log('No total_price items, returning 0');
            return 0;    
        },

        async loadAddons() {
            if (!this.event || !this.event.id) {
                return;
            }

            this.addonsLoading = true;
            try {
                const response = await axios.get(`/api/events/${this.event.id}/addons`);
                if (response.data && response.data.success) {
                    this.addons = response.data.data || [];
                } else {
                    this.addons = [];
                }
            } catch (error) {
                console.error('Erro ao carregar add-ons:', error);
                this.addons = [];
            } finally {
                this.addonsLoading = false;
            }
        },

        addonsTotal() {
            if (!this.addons || this.addons.length === 0) {
                return 0;
            }
            if (!this.selectedAddonIds || this.selectedAddonIds.length === 0) {
                return 0;
            }

            const quantity = this.bookedTicketsTotal();
            let total = 0;
            const selectedIds = (this.selectedAddonIds || []).map(id => parseInt(id));
            this.addons.forEach(addon => {
                if (!selectedIds.includes(parseInt(addon.id))) {
                    return;
                }

                const price = parseFloat(addon.price) || 0;
                if (addon.pricing_type === 'per_order') {
                    total += price;
                    return;
                }

                total += (price * quantity);
            });

            return parseFloat(total.toFixed(2));
        },

        onAddonSelectionChanged() {
            this.totalPrice();
            this.orderTotal();
            if (this.useMultiParticipantCheckout) {
                this.showPaymentForm = false;
                this.refreshCheckoutPrepare();
            }
        },

        getAddonSelectionsPayload() {
            return {
                selected: (this.selectedAddonIds || []).map(id => parseInt(id))
            };
        },

        formatMoney(value) {
            const num = parseFloat(value);
            if (isNaN(num)) {
                return '0.00';
            }
            return num.toFixed(2);
        },

        // total booked tickets
        bookedTicketsTotal() {
            if (this.useMultiParticipantCheckout && Array.isArray(this.participants) && this.participants.length > 0) {
                return this.participants.length;
            }
            let  total = 0
            if(this.quantity.length > 0)
            {
                this.quantity.forEach(function(value, key){
                    total = parseInt(total) + parseInt(value);

                }.bind(this))

                return total;
            }
            return 0;    
        },

        applyMultiParticipantTicketQuantityToFormData(post_data) {
            if (!this.useMultiParticipantCheckout) {
                return;
            }
            if (!post_data) {
                return;
            }

            let ticketId = this.selectedTicket && this.selectedTicket.id ? this.selectedTicket.id : null;
            if (!ticketId && Array.isArray(this.tickets)) {
                for (let i = 0; i < this.tickets.length; i++) {
                    if (this.quantity && this.quantity[i] && parseInt(this.quantity[i], 10) > 0) {
                        ticketId = this.tickets[i].id;
                        break;
                    }
                }
            }
            if (!ticketId && Array.isArray(this.tickets) && this.tickets.length > 0) {
                ticketId = this.tickets[0].id;
            }

            const qty = Math.max(parseInt(this.bookedTicketsTotal() || 0, 10) || 0, 1);

            post_data.delete('ticket_id[]');
            post_data.delete('quantity[]');
            post_data.append('ticket_id[]', ticketId);
            post_data.append('quantity[]', qty);
        },

        defaultPaymentMethod() {
            if (this.bookedTicketsTotal() <= 0) {
                return;
            }

            if ((parseFloat(this.total) || 0) <= 0) {
                this.payment_method = 'offline';
                return;
            }

            if ((this.is_mercadopago || 0) > 0) {
                this.payment_method = 2;
                return;
            }

            if (this.is_admin <= 0 && (this.is_paypal || 0) > 0) {
                this.payment_method = 1;
                return;
            }

            this.payment_method = 'offline';
        },

        loginFirst() {
            window.location.href = route('eventmie.login_first');
        },
        signupFirst() {
            window.location.href = route('eventmie.signup_first');
        },

        // get customers

        getCustomers(loading, search = null){
            var postUrl     = route('eventmie.get_customers');
            var _this       = this;
            axios.post(postUrl,{
                'search' :search,
            }).then(res => {
                
                var promise = new Promise(function(resolve, reject) { 
                    
                    _this.options = res.data.customers;
                    
                    resolve(true);
                }) 
                
                promise 
                    .then(function(successMessage) { 
                        loading(false);
                    }, function(errorMessage) { 
                    //error handler function is invoked 
                        console.log(errorMessage); 
                    }) 
            })
            .catch(error => {
                let serrors = Vue.helpers.axiosErrors(error);
                if (serrors.length) {
                    this.serverValidate(serrors);
                }
            });
        },
        
        // v-select methods
        onSearch(search, loading) {
            loading(true);
            this.search(loading, search, this);
        },

        // v-select methods
        search: _.debounce((loading, search, vm) => {
            
            // 🔧 AJUSTE: Permitir busca por CPF, e-mail ou nome (mínimo 3 caracteres)
            if(search && search.length >= 3)
                vm.getCustomers(loading, search);
            else
                loading(false);    
            
        }, 350),

        validateEmail(email) {
            const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        scrollToBottom() {
            this.$refs["bottom-down"].scrollIntoView({ block: "end", inline: "nearest" })
        },

        // 🎯 NOVOS MÉTODOS DE SEGMENTAÇÃO
        onPriceAdjusted(adjustmentData, ticketIndex) {
            
            // Validar dados recebidos
            if (!adjustmentData) {
                console.error('adjustmentData é undefined');
                return;
            }
            
            // Garantir que todos os valores são números válidos
            const adjustment = parseFloat(adjustmentData.adjustment) || 0;
            const originalPrice = parseFloat(adjustmentData.originalPrice) || 0;
            const finalPrice = parseFloat(adjustmentData.finalPrice) || originalPrice;
            const priceReplaced = adjustmentData.priceReplaced || false;
            
            
            // Armazenar dados completos de preço
            this.$set(this.segmentPriceAdjustments, ticketIndex, {
                adjustment: adjustment,
                originalPrice: originalPrice,
                finalPrice: finalPrice,
                priceReplaced: priceReplaced,
                appliedClassification: adjustmentData.appliedClassification
            });
            
            this.totalPrice();
            this.orderTotal();
        },

        validateSegmentSelections() {
            this.segmentSelectionsPayload = {};

            let isValid = true;
            let hasAnySelector = false;

            for (let i = 0; i < this.tickets.length; i++) {
                if (this.quantity[i] > 0 && this.event.segment_id) {
                    const segmentSelector = this.resolveComponentRef(this.$refs[`segmentSelector_${i}`]);
                    if (segmentSelector && typeof segmentSelector.validate === 'function' && typeof segmentSelector.getValues === 'function') {
                        hasAnySelector = true;
                        if (!segmentSelector.validate()) {
                            isValid = false;
                        }
                        this.segmentSelectionsPayload[this.tickets[i].id] = segmentSelector.getValues();
                    } else {
                        isValid = false;
                    }
                }
            }

            if (this.event.segment_id && !hasAnySelector) {
                return false;
            }

            return isValid;
        },

        getSegmentSelectionsPayload() {
            const payload = {};

            for (let i = 0; i < this.tickets.length; i++) {
                if (this.quantity[i] > 0 && this.event.segment_id) {
                    const segmentSelector = this.resolveComponentRef(this.$refs[`segmentSelector_${i}`]);
                    if (segmentSelector && typeof segmentSelector.getValues === 'function') {
                        payload[this.tickets[i].id] = segmentSelector.getValues();
                    }
                }
            }

            return payload;
        },

        resolveComponentRef(refValue) {
            if (Array.isArray(refValue)) {
                return refValue[0] || null;
            }
            return refValue || null;
        },

        validateParticipantsSegmentSelections() {
            if (!this.useMultiParticipantCheckout || !this.event || !this.event.segment_id) {
                return true;
            }

            let isValid = true;
            const totalParticipants = Array.isArray(this.participants) ? this.participants.length : 0;

            for (let participantIndex = 0; participantIndex < totalParticipants; participantIndex++) {
                const segmentSelector = this.resolveComponentRef(this.$refs[`segmentSelector_participant_${participantIndex}`]);
                if (!segmentSelector || typeof segmentSelector.validate !== 'function' || typeof segmentSelector.getValues !== 'function') {
                    isValid = false;
                    continue;
                }

                if (!segmentSelector.validate()) {
                    isValid = false;
                }

                const values = segmentSelector.getValues();
                if (this.participants && this.participants[participantIndex]) {
                    this.$set(this.participants[participantIndex], 'segment_selections', values || {});
                }
            }

            return isValid;
        },

        buildSegmentSelectionsPayloadFromParticipants() {
            if (!this.useMultiParticipantCheckout || !this.event || !this.event.segment_id) {
                return {};
            }

            let ticketId = this.selectedTicket && this.selectedTicket.id ? this.selectedTicket.id : null;
            if (!ticketId && Array.isArray(this.tickets)) {
                for (let i = 0; i < this.tickets.length; i++) {
                    if (this.quantity[i] && parseInt(this.quantity[i]) > 0) {
                        ticketId = this.tickets[i].id;
                        break;
                    }
                }
            }

            if (!ticketId) {
                return {};
            }

            const merged = {};
            (this.participants || []).forEach((p) => {
                const selections = p && p.segment_selections ? p.segment_selections : {};
                if (!selections || typeof selections !== 'object') {
                    return;
                }

                Object.keys(selections).forEach((classificationId) => {
                    const value = selections[classificationId];
                    if (value === null || value === '' || (Array.isArray(value) && value.length === 0)) {
                        return;
                    }
                    if (typeof merged[classificationId] === 'undefined') {
                        merged[classificationId] = value;
                    }
                });
            });

            return {
                [ticketId]: merged
            };
        },

        getSegmentSelectionsPayloadForRequest() {
            if (!this.event || !this.event.segment_id) {
                return {};
            }

            if (this.useMultiParticipantCheckout) {
                return this.buildSegmentSelectionsPayloadFromParticipants();
            }

            if (this.segmentSelectionsPayload && Object.keys(this.segmentSelectionsPayload).length > 0) {
                return this.segmentSelectionsPayload;
            }

            return this.getSegmentSelectionsPayload();
        },

        getSegmentDataForBooking() {
            // Preparar dados de segmentação para envio no booking
            const segmentData = {};
            
            for (let i = 0; i < this.tickets.length; i++) {
                if (this.quantity[i] > 0 && this.event.segment_id) {
                    const segmentSelector = this.resolveComponentRef(this.$refs[`segmentSelector_${i}`]);
                    if (segmentSelector && typeof segmentSelector.getValues === 'function') {
                        segmentData[this.tickets[i].id] = {
                            selections: segmentSelector.getValues(),
                            price_adjustment: this.segmentPriceAdjustments[i] || 0
                        };
                    }
                }
            }
            
            return segmentData;
        },

        // 🎯 Handle quantity change with login validation first
        handleQuantityChange(index) {
            // First check if user is logged in before allowing quantity selection
            if (!this.login_user_id) {
                // Reset quantity to 0
                this.$set(this.quantity, index, 0);
                this.totalPrice();
                
                // Show login required message
                Vue.helpers.showToast('info', 'Faça login para selecionar ingressos');
                return;
            }
            
            // If logged in, proceed with normal quantity change
            this.onQuantityChange(index);
        },

        // 🎯 Quantity change handler - loads kit variations automatically
        async onQuantityChange(index) {
            // 🚨 VALIDAÇÃO ANTI-DUPLICAÇÃO: Verificar se usuário já tem booking pendente
            const hasQuantity = Object.values(this.quantity).some(qty => qty > 0);
            
            if (hasQuantity && this.is_customer > 0) {
                try {
                    const response = await axios.get(`/bookings/api/check-existing-booking/${this.event.id}`, {
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        }
                    });
                    
                    if (response.data && response.data.has_pending_booking) {
                        // Resetar quantidade para 0
                        this.$set(this.quantity, index, 0);
                        this.totalPrice();
                        
                        // Usar mensagem dinâmica da API baseada no status do booking
                        const message = response.data.message || 'Você já possui uma reserva para este evento.';
                        const toastType = 'warning';
                        
                        // Mostrar alerta usando Vue.helpers.showToast
                        if (Vue.helpers && typeof Vue.helpers.showToast === 'function') {
                            Vue.helpers.showToast(toastType, message);
                        } else if (window.showToast && typeof window.showToast === 'function') {
                            window.showToast(toastType, message);
                        } else {
                            // Fallback: usar alert
                            alert('Reserva Existente: ' + message);
                        }
                        return;
                    }
                } catch (error) {
                    console.error('Erro ao verificar booking existente:', error);
                    // Em caso de erro na verificação, permitir continuar mas logar o erro
                }
            }
            
            // Load kit variations if event has kit and variations not loaded yet
            if (this.event && this.event.kit_id && this.kitVariations.length === 0) {
                this.loadKitVariations();
            }
            
            // Also call totalPrice to update prices
            this.totalPrice();
        },


        async loadKitPreview() {
            if (!this.event || !this.event.id || !this.event.kit_id) {
                this.kitPreview = null;
                this.kitPreviewLoading = false;
                return;
            }

            if (this.kitPreviewLoading) {
                return;
            }

            try {
                this.kitPreviewLoading = true;
                const apiUrl = `/bookings/api/events/${this.event.id}/kit-preview`;
                const config = {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    }
                };

                const response = await axios.get(apiUrl, config);

                if (response.data && response.data.success) {
                    this.kitPreview = response.data.data;
                } else {
                    this.kitPreview = null;
                }
            } catch (error) {
                this.kitPreview = null;
            } finally {
                this.kitPreviewLoading = false;
            }
        },

        getKitPreviewImageUrl(imagePath) {
            if (!imagePath) {
                return null;
            }

            if (typeof imagePath === 'string' && imagePath.startsWith('data:')) {
                return imagePath;
            }

            if (typeof imagePath === 'string' && imagePath.startsWith('http')) {
                return imagePath;
            }

            return `/storage/${imagePath}`;
        },

        // 📦 Kit Variations Methods
        async loadKitVariations() {
            if (!this.event || !this.event.id) {
                return;
            }

            // Only load kit variations if user is logged in
            if (!this.login_user_id) {
                this.kitVariations = [];
                this.kitVariationsLoadError = '';
                this.kitVariationsLoading = false;
                return;
            }

            try {
                this.kitVariationsLoading = true;
                this.kitVariationsLoadError = '';
                const apiUrl = `/bookings/api/events/${this.event.id}/kit-variations`;
                const config = {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    }
                };
                
                const response = await axios.get(apiUrl, config);
                
                if (response.data && response.data.success) {
                    this.kitVariations = response.data.data || [];
                    this.initializeSelectedKitVariations();
                } else {
                    this.kitVariations = [];
                    this.kitVariationsLoadError = (response && response.data && response.data.message) ? response.data.message : 'Erro ao carregar variações do kit';
                }
            } catch (error) {
                this.kitVariations = [];
                this.kitVariationsLoadError = 'Erro ao carregar variações do kit';
                console.error('❌ Erro ao carregar variações do kit:', error?.message || error);
            } finally {
                this.kitVariationsLoading = false;
            }
        },

        initializeSelectedKitVariations() {
            // Initialize selected variations structure for each ticket
            this.selectedKitVariations = {};
            this.kitVariationErrors = {};
            
            for (let ticketIndex = 0; ticketIndex < this.tickets.length; ticketIndex++) {
                this.selectedKitVariations[ticketIndex] = {};
                
                this.kitVariations.forEach((kitItem, kitIndex) => {
                    this.selectedKitVariations[ticketIndex][kitIndex] = {};
                    
                    // Kit item agora tem options diretamente, não variants
                    if (kitItem.options && kitItem.options.length > 0) {
                        this.selectedKitVariations[ticketIndex][kitIndex] = '';
                    }
                });
            }
            
            // Force reactivity
            this.$forceUpdate();
        },

        validateKitVariations(ticketIndex) {
            let isValid = true;
            this.kitVariationErrors = {};
            
            if (this.quantity[ticketIndex] > 0 && this.kitVariations.length > 0) {
                this.kitVariations.forEach((kitItem, kitIndex) => {
                    const key = `${ticketIndex}_${kitIndex}`;
                    const selectedValue = this.selectedKitVariations[ticketIndex][kitIndex];
                    const selectableCount = typeof kitItem.selectable_options_count !== 'undefined'
                        ? parseInt(kitItem.selectable_options_count, 10)
                        : (kitItem.options || []).filter(opt => (opt && opt.stock > 0)).length;
                    
                    if (kitItem.is_required && selectableCount <= 0) {
                        this.kitVariationErrors[key] = `${kitItem.name} está esgotado no momento`;
                        isValid = false;
                        return;
                    }
                    
                    if (kitItem.is_required && (!selectedValue || selectedValue === '')) {
                        this.kitVariationErrors[key] = `${kitItem.name} é obrigatório`;
                        isValid = false;
                    }
                });
            }
            
            return isValid;
        },

        validateAllKitVariations() {
            let isValid = true;
            
            for (let ticketIndex = 0; ticketIndex < this.tickets.length; ticketIndex++) {
                if (this.quantity[ticketIndex] > 0) {
                    if (!this.validateKitVariations(ticketIndex)) {
                        isValid = false;
                    }
                }
            }
            
            return isValid;
        },

        getKitVariationsForBooking() {
            const kitVariationsData = {};
            
            for (let ticketIndex = 0; ticketIndex < this.tickets.length; ticketIndex++) {
                if (this.quantity[ticketIndex] > 0 && this.selectedKitVariations[ticketIndex]) {
                    const ticketVariations = {};
                    
                    this.kitVariations.forEach((kitItem, kitIndex) => {
                        const selectedValue = this.selectedKitVariations[ticketIndex][kitIndex];
                        if (selectedValue) {
                            ticketVariations[kitIndex] = selectedValue;
                        }
                    });
                    
                    if (Object.keys(ticketVariations).length > 0) {
                        kitVariationsData[this.tickets[ticketIndex].id] = ticketVariations;
                    }
                }
            }
            
            return kitVariationsData;
        },

        buildKitSelectionsPayloadFromParticipants() {
            if (!this.useMultiParticipantCheckout || !this.event || !this.event.kit_id) {
                return [];
            }

            const rows = [];
            (this.participants || []).forEach((participant) => {
                const variations = participant && participant.kit_variations ? participant.kit_variations : {};
                if (!variations || typeof variations !== 'object') {
                    return;
                }

                Object.keys(variations).forEach((kitIndex) => {
                    const value = variations[kitIndex];
                    if (!value || value === '') {
                        return;
                    }
                    rows.push({
                        variant_id: value,
                        quantity: 1,
                    });
                });
            });

            return rows;
        },

        getKitSelectionsPayloadForRequest() {
            if (!this.event || !this.event.kit_id) {
                return {};
            }

            if (this.useMultiParticipantCheckout) {
                return this.buildKitSelectionsPayloadFromParticipants();
            }

            const filtered = this.getKitVariationsForBooking();
            if (filtered && Object.keys(filtered).length > 0) {
                return filtered;
            }

            if (this.selectedKitVariations) {
                return this.selectedKitVariations;
            }

            return {};
        },

        // 🎫 MÉTODOS DE CORTESIA
        onDiscountApplied(discountData) {
            console.log('Desconto aplicado:', discountData);
            console.log('Total atual antes do desconto:', this.total);
            
            this.courtesyDiscount = discountData;
            this.originalTotal = parseFloat(this.total);
            this.total = parseFloat(discountData.final_amount).toFixed(2);
            
            console.log('Total após desconto:', this.total);
        },

        onDiscountRemoved() {
            if (this.courtesyDiscount) {
                this.total = this.originalTotal;
                this.courtesyDiscount = null;
                this.originalTotal = 0;
            }
        },

        getParticipantCourtesyBaseAmount(userId) {
            const key = String(userId || '');
            const row = this.participantsBaseTotalsByUserId ? this.participantsBaseTotalsByUserId[key] : null;
            if (row && typeof row.total !== 'undefined') {
                return parseFloat(row.total) || 0;
            }
            return 0;
        },

        getParticipantCourtesyTaxAmount(userId) {
            const key = String(userId || '');
            const row = this.participantsBaseTotalsByUserId ? this.participantsBaseTotalsByUserId[key] : null;
            if (row && typeof row.tax !== 'undefined') {
                return parseFloat(row.tax) || 0;
            }
            return 0;
        },

        getParticipantDiscountMultiplier(userId) {
            const key = String(userId || '');
            if (!key) {
                return 1;
            }
            const ratio = this.participantCourtesyDiscountMultiplierByUserId
                ? this.participantCourtesyDiscountMultiplierByUserId[key]
                : null;
            const parsed = parseFloat(ratio);
            if (!isNaN(parsed) && parsed >= 0 && parsed <= 1) {
                return parsed;
            }
            return 1;
        },

        onParticipantCourtesyApplied(discountData, userId) {
            if (!this.useMultiParticipantCheckout) {
                this.onDiscountApplied(discountData);
                return;
            }

            const key = String(userId || '');
            if (!key) {
                return;
            }

            this.$set(this.courtesyCodesByUserId, key, {
                courtesy_code_id: discountData.courtesy_code_id,
                cpf_used: discountData.cpf_used || null,
            });

            const original = parseFloat(discountData.original_amount);
            const finalAmount = parseFloat(discountData.final_amount);
            if (!isNaN(original) && original > 0 && !isNaN(finalAmount) && finalAmount >= 0) {
                const multiplier = finalAmount / original;
                this.$set(this.participantCourtesyDiscountMultiplierByUserId, key, multiplier);
            } else {
                this.$delete(this.participantCourtesyDiscountMultiplierByUserId, key);
            }

            this.showPaymentForm = false;
            this.refreshCheckoutPrepare();
        },

        onParticipantCourtesyRemoved(userId) {
            if (!this.useMultiParticipantCheckout) {
                this.onDiscountRemoved();
                return;
            }

            const key = String(userId || '');
            if (!key) {
                return;
            }

            if (this.courtesyCodesByUserId && Object.prototype.hasOwnProperty.call(this.courtesyCodesByUserId, key)) {
                this.$delete(this.courtesyCodesByUserId, key);
            }

            if (this.participantCourtesyDiscountMultiplierByUserId && Object.prototype.hasOwnProperty.call(this.participantCourtesyDiscountMultiplierByUserId, key)) {
                this.$delete(this.participantCourtesyDiscountMultiplierByUserId, key);
            }

            this.showPaymentForm = false;
            this.refreshCheckoutPrepare();
        },

        // Event Status Methods
        showEventStatusAlert() {
            return this.event && this.event.event_status && 
                   ['courtesy_mode', 'marketing_mode', 'inactive_mode'].includes(this.event.event_status);
        },

        getEventStatusAlertClass() {
            const classes = {
                'courtesy_mode': 'alert-warning',
                'marketing_mode': 'alert-info',
                'inactive_mode': 'alert-secondary'
            };
            return classes[this.event.event_status] || 'alert-info';
        },

        getEventStatusIcon() {
            const icons = {
                'courtesy_mode': 'fas fa-gift text-warning',
                'marketing_mode': 'fas fa-bullhorn text-info',
                'inactive_mode': 'fas fa-pause text-secondary'
            };
            return icons[this.event.event_status] || 'fas fa-info-circle';
        },

        getEventStatusTitle() {
            const titles = {
                'courtesy_mode': 'Modo Cortesia Ativo',
                'marketing_mode': 'Modo Marketing',
                'inactive_mode': 'Evento Inativo'
            };
            return titles[this.event.event_status] || 'Informação';
        },

        getEventStatusMessage() {
            const messages = {
                'courtesy_mode': 'Este evento está em modo cortesia. É necessário um código de cortesia para realizar a compra.',
                'marketing_mode': 'Este evento está visível apenas para divulgação. As vendas foram encerradas.',
                'inactive_mode': 'Este evento está temporariamente inativo.'
            };
            return messages[this.event.event_status] || '';
        },

        // Check if tickets should be disabled based on event status
        isTicketSelectionDisabled() {
            return this.event && ['marketing_mode', 'inactive_mode'].includes(this.event.event_status);
        },

        // Check if courtesy code is required
        isCourtesyCodeRequired() {
            return this.event && this.event.event_status === 'courtesy_mode';
        },

        // Check if a valid courtesy code has been applied
        hasValidCourtesyCode() {
            if (this.useMultiParticipantCheckout) {
                if (!this.isCourtesyCodeRequired()) {
                    return true;
                }
                if (!Array.isArray(this.participants) || this.participants.length === 0) {
                    return false;
                }
                return this.participants.every((p) => {
                    const key = String(p.user_id || '');
                    return !!(key && this.courtesyCodesByUserId && this.courtesyCodesByUserId[key] && this.courtesyCodesByUserId[key].courtesy_code_id);
                });
            }

            // Verificar se existe um desconto de cortesia aplicado
            // Aceitar tanto discount_amount > 0 quanto discount_amount >= 0 (para códigos gratuitos)
            return this.courtesyDiscount && 
                   this.courtesyDiscount.courtesy_code_id && 
                   typeof this.courtesyDiscount.discount_amount !== 'undefined';
        },

        // 🔒 NOVO: Handle segment selection changes for limit validation
        onSegmentSelectionChanged(selections, ticketIndex) {
            // Store segment selections for limit validation
            this.$set(this.segmentSelections, ticketIndex, selections);
            
            // If limit validation is enabled, trigger validation
            if (this.enable_limit_validation && selections) {
                this.validateSegmentLimits(ticketIndex);
            }
        },

        /**
         * 🔒 Exibir erro crítico com toast personalizado
         */
        showCriticalError(title, message, type = 'error', redirect_profile = false) {
            // Toast com título e ícone específicos
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-right',
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', Swal.stopTimer)
                    toast.addEventListener('mouseleave', Swal.resumeTimer)
                }
            });
            
            let iconClass = 'fa-exclamation-triangle';
            if (type === 'error') iconClass = 'fa-times-circle';
            if (type === 'warning') iconClass = 'fa-exclamation-triangle';
            if (type === 'info') iconClass = 'fa-info-circle';
            
            Toast.fire({
                icon: type,
                title: `<strong>${title}</strong>`,
                html: `<i class="fas ${iconClass} fs-5 me-2"></i>${message}`,
                background: type === 'error' ? '#fee' : '#fff',
                color: type === 'error' ? '#721c24' : '#333'
            });
            
            // Redirecionar para perfil se necessário
            if (redirect_profile) {
                setTimeout(() => {
                    console.log('🔄 Redirecionando para perfil do usuário...');
                    window.location.href = '/profile';
                }, 3000);
            }
            
            // Log para debug
            console.warn(`CHECKOUT BLOQUEADO: ${title}`, {
                type: type,
                message: message,
                redirect_profile: redirect_profile,
                timestamp: new Date().toISOString()
            });
        },

        // 🔒 VALIDAÇÃO CPF/CNPJ DO USUÁRIO
        validateUserDocument() {
            console.log('🔒 Validando CPF/CNPJ do usuário...');
            
            // Verificar se usuário está logado
            if (!window.currentUser || !window.currentUser.id) {
                this.showCriticalError('Login Necessário', 'Você precisa estar logado para continuar a compra.', 'error');
                return false;
            }

            const user = window.currentUser;
            console.log('🔒 Dados do usuário:', {
                id: user.id,
                email: user.email,
                document: user.document,
                document_type: user.document_type
            });

            // Verificar se documento está preenchido
            if (!user.document || user.document.trim() === '') {
                this.showCriticalError(
                    'CPF/CNPJ Obrigatório', 
                    'Complete seu CPF/CNPJ no perfil antes de continuar a compra.',
                    'error',
                    true // redirect_profile
                );
                return false;
            }

            // Limpar documento (remover formatação)
            const document = user.document.replace(/[^0-9]/g, '');
            console.log('🔒 Documento limpo:', document);

            // Verificar se é CPF (11 dígitos) ou CNPJ (14 dígitos)
            if (document.length === 11) {
                // Validar CPF
                if (!this.isValidCPF(document)) {
                    this.showCriticalError(
                        'CPF Inválido', 
                        'O CPF informado em seu perfil é inválido. Corrija os dados antes de continuar.',
                        'error',
                        true // redirect_profile
                    );
                    return false;
                }
                console.log('✅ CPF válido');
            } else if (document.length === 14) {
                // Validar CNPJ
                if (!this.isValidCNPJ(document)) {
                    this.showCriticalError(
                        'CNPJ Inválido', 
                        'O CNPJ informado em seu perfil é inválido. Corrija os dados antes de continuar.',
                        'error',
                        true // redirect_profile
                    );
                    return false;
                }
                console.log('✅ CNPJ válido');
            } else {
                this.showCriticalError(
                    'Documento Inválido', 
                    'CPF deve ter 11 dígitos ou CNPJ deve ter 14 dígitos. Corrija os dados em seu perfil.',
                    'error',
                    true // redirect_profile
                );
                return false;
            }

            return true;
        },

        // 🔒 VALIDAR CPF USANDO ALGORITMO OFICIAL
        isValidCPF(cpf) {
            // Verificar se todos os dígitos são iguais
            if (/(\d)\1{10}/.test(cpf)) {
                return false;
            }

            // Calcular primeiro dígito verificador
            let sum = 0;
            for (let i = 0; i < 9; i++) {
                sum += parseInt(cpf[i]) * (10 - i);
            }
            let remainder = sum % 11;
            let digit1 = remainder < 2 ? 0 : 11 - remainder;

            // Calcular segundo dígito verificador
            sum = 0;
            for (let i = 0; i < 10; i++) {
                sum += parseInt(cpf[i]) * (11 - i);
            }
            remainder = sum % 11;
            let digit2 = remainder < 2 ? 0 : 11 - remainder;

            // Verificar se os dígitos calculados conferem
            return parseInt(cpf[9]) === digit1 && parseInt(cpf[10]) === digit2;
        },

        // 🔒 VALIDAR CNPJ USANDO ALGORITMO OFICIAL
        isValidCNPJ(cnpj) {
            // Verificar se todos os dígitos são iguais
            if (/(\d)\1{13}/.test(cnpj)) {
                return false;
            }

            // Calcular primeiro dígito verificador
            let sum = 0;
            const weights1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
            for (let i = 0; i < 12; i++) {
                sum += parseInt(cnpj[i]) * weights1[i];
            }
            let remainder = sum % 11;
            let digit1 = remainder < 2 ? 0 : 11 - remainder;

            // Calcular segundo dígito verificador
            sum = 0;
            const weights2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
            for (let i = 0; i < 13; i++) {
                sum += parseInt(cnpj[i]) * weights2[i];
            }
            remainder = sum % 11;
            let digit2 = remainder < 2 ? 0 : 11 - remainder;

            // Verificar se os dígitos calculados conferem
            return parseInt(cnpj[12]) === digit1 && parseInt(cnpj[13]) === digit2;
        },

        // 🔒 NOVO: Handle limit validation results
        onLimitValidation(result, ticketIndex) {
            this.$set(this.limitValidationResults, ticketIndex, result);
            
            // Store any validation errors
            if (result.hasErrors) {
                this.$set(this.limitValidationErrors, ticketIndex, result.errors);
            } else {
                this.$delete(this.limitValidationErrors, ticketIndex);
            }
        },

        // 🔒 NOVO: Validate segment limits for a specific ticket
        async validateSegmentLimits(ticketIndex) {
            if (!this.enable_limit_validation || !this.segmentSelections[ticketIndex]) {
                return true;
            }

            try {
                const response = await axios.post('/api/segments/validate-limits', {
                    ticket_id: this.tickets[ticketIndex].id,
                    quantity: this.quantity[ticketIndex],
                    segment_selections: this.segmentSelections[ticketIndex],
                    event_id: this.event.id
                });

                const result = response.data;
                this.onLimitValidation(result, ticketIndex);
                
                return !result.hasErrors;
            } catch (error) {
                console.error('Erro ao validar limites:', error);
                this.$set(this.limitValidationErrors, ticketIndex, ['Erro ao validar disponibilidade. Tente novamente.']);
                return false;
            }
        },

        // 🔒 NOVO: Check if all limit validations are OK before checkout
        validateAllLimits() {
            if (!this.enable_limit_validation) {
                return true;
            }

            // Check if there are any validation errors
            for (let ticketIndex in this.limitValidationErrors) {
                if (this.limitValidationErrors[ticketIndex] && this.limitValidationErrors[ticketIndex].length > 0) {
                    return false;
                }
            }

            return true;
        },

    },

    watch: {
        payment_method(newValue) {
            // Quando selecionar Mercado Pago, mostrar o formulário
            if (newValue == 2) {
                this.$nextTick(() => {
                    this.scrollToMercadoPagoForm();
                });

                if (!this.useMultiParticipantCheckout) {
                    this.initializeMultiParticipantCheckout();
                }
            }
        },

        quantity: {
            handler(newVal) {
                this.totalPrice();
                this.orderTotal();
                this.defaultPaymentMethod();

                const hasQuantity = Object.values(newVal || {}).some(qty => qty > 0);
                if (this.event && this.event.kit_id && this.kitVariations.length === 0 && hasQuantity) {
                    this.loadKitVariations();
                }
            },
            deep: true
        },

        tickets: function() {
            this.setDefaultQuantity();
            this.totalPrice();
            this.orderTotal();
        },

        event: {
            handler(newVal) {
                if (newVal && newVal.id) {
                    this.loadAddons();
                    this.loadKitPreview();
                }
            },
            deep: true
        },

        // active when customer search
        customer: function () {
            this.customer_id = this.customer != null ?  this.customer.id : null;
        },
    },

    mounted() {
        this.openModal = true;
        this.setDefaultQuantity();
        this.defaultPaymentMethod();
    },
}
</script>
<style>
    .preserve-whitespace {
        white-space: pre-line;
    }

    .checkout-flow-wrapper {
        max-width: 920px;
        margin-left: auto;
        margin-right: auto;
    }

    .checkout-section-card {
        border-radius: 16px;
    }

    .checkout-step {
        width: 34px;
        height: 34px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border-radius: 999px;
        background: rgba(13, 110, 253, 0.12);
        color: #0d6efd;
        font-weight: 800;
        flex: 0 0 auto;
    }

    .checkout-cta {
        border-radius: 14px;
        padding-top: 0.9rem;
        padding-bottom: 0.9rem;
    }

    .checkout-flow-wrapper .btn-success,
    .checkout-flow-wrapper .btn-success:hover,
    .checkout-flow-wrapper .btn-success:focus,
    .checkout-flow-wrapper .btn-success:active {
        color: #ffffff !important;
    }

    .checkout-flow-wrapper .btn-success strong {
        color: inherit !important;
    }

    .checkout-flow-wrapper .btn-outline-primary:hover,
    .checkout-flow-wrapper .btn-outline-primary:focus,
    .checkout-flow-wrapper .btn-outline-primary:active,
    .checkout-flow-wrapper .btn-primary:hover,
    .checkout-flow-wrapper .btn-primary:focus,
    .checkout-flow-wrapper .btn-primary:active {
        background-color: #0b427b !important;
        border-color: #0b427b !important;
        color: #ffffff !important;
    }

    .checkout-participant-card {
        border-radius: 14px;
    }

    .checkout-progress {
        width: 100%;
        height: 6px;
        background: rgba(13, 110, 253, 0.10);
        border-radius: 999px;
        overflow: hidden;
    }

    .checkout-progress-bar {
        height: 100%;
        background: linear-gradient(90deg, rgba(13, 110, 253, 0.55), rgba(25, 135, 84, 0.85));
        border-radius: 999px;
        transition: width 260ms ease;
    }

    .checkout-collapse-enter-active,
    .checkout-collapse-leave-active {
        transition: opacity 200ms ease, transform 200ms ease;
    }

    .checkout-collapse-enter,
    .checkout-collapse-leave-to {
        opacity: 0;
        transform: translateY(-4px);
    }

    @media (max-width: 576px) {
        .checkout-flow-wrapper {
            padding-left: 8px;
            padding-right: 8px;
        }

        .w-40,
        .w-20 {
            width: 100% !important;
        }
    }

    /* Event Status Styles */
    .grayscale-tickets {
        filter: grayscale(100%);
        opacity: 0.7;
    }

    .grayscale-tickets .list-group-item {
        background-color: #f8f9fa !important;
        border-color: #dee2e6 !important;
    }

    .grayscale-tickets .list-group-item h6,
    .grayscale-tickets .list-group-item p,
    .grayscale-tickets .list-group-item strong {
        color: #6c757d !important;
    }

    .grayscale-tickets select,
    .grayscale-tickets input {
        background-color: #e9ecef !important;
        color: #6c757d !important;
        cursor: not-allowed;
    }

    /* Courtesy Mode Highlight */
    .courtesy-mode-highlight {
        border: 2px solid #ffc107 !important;
        background: linear-gradient(135deg, rgba(255, 193, 7, 0.1) 0%, rgba(255, 255, 255, 0.1) 100%);
        box-shadow: 0 0 15px rgba(255, 193, 7, 0.3);
        animation: courtesy-pulse 2s infinite;
    }

    @keyframes courtesy-pulse {
        0% { box-shadow: 0 0 15px rgba(255, 193, 7, 0.3); }
        50% { box-shadow: 0 0 25px rgba(255, 193, 7, 0.5); }
        100% { box-shadow: 0 0 15px rgba(255, 193, 7, 0.3); }
    }

    /* Marketing Mode Disabled */
    .marketing-mode-disabled {
        pointer-events: none;
        opacity: 0.5;
        filter: grayscale(50%);
    }

    /* Inactive Mode Styles */
    .inactive-mode-content {
        filter: grayscale(100%);
        opacity: 0.6;
    }

    .kit-preview-card {
        overflow: hidden;
    }

    .kit-preview-item {
        transition: transform 0.18s ease, box-shadow 0.18s ease;
    }

    .kit-preview-item:hover {
        transform: translateY(-2px);
        box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.12) !important;
    }

    .kit-preview-img {
        object-fit: cover;
        transition: transform 0.35s ease;
    }

    .kit-preview-item:hover .kit-preview-img {
        transform: scale(1.03);
    }

    .kit-preview-desc {
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }
</style>
